import React, { useEffect, useMemo, useState } from "react";
import { Helmet } from "react-helmet";
import { useParams, Navigate, Link } from "react-router-dom";
import Header from "../components/layout/Header";
import Footer from "../components/layout/Footer";

import Testimonials from "../components/Testimonials";







const iconClassName = "h-7 w-7 md:h-8 md:w-8";

const serviceIcons = {
  shield: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={iconClassName}
    >
      <path d="M12 3l7 3v6c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6l7-3z" />
      <path d="M9 12l2 2 4-4" />
    </svg>
  ),

  purity: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={iconClassName}
    >
      <path d="M12 3v18" />
      <path d="M5 7h14" />
      <path d="M7 7l-3 5a3 3 0 0 0 6 0L7 7z" />
      <path d="M17 7l-3 5a3 3 0 0 0 6 0l-3-5z" />
    </svg>
  ),

  pricing: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={iconClassName}
    >
      <path d="M4 18h16" />
      <path d="M7 14l3-3 3 2 4-5" />
      <circle cx="7" cy="14" r="1" />
      <circle cx="10" cy="11" r="1" />
      <circle cx="13" cy="13" r="1" />
      <circle cx="17" cy="8" r="1" />
    </svg>
  ),

  payment: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={iconClassName}
    >
      <rect x="3" y="6" width="18" height="12" rx="2" />
      <path d="M3 10h18" />
      <path d="M7 14h4" />
      <path d="M15 13l1.5 1.5L19 12" />
    </svg>
  ),

  document: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={iconClassName}
    >
      <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" />
      <path d="M14 3v5h5" />
      <path d="M9 13l2 2 4-4" />
    </svg>
  ),

  branch: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={iconClassName}
    >
      <path d="M12 21s-6-5.2-6-10a6 6 0 1 1 12 0c0 4.8-6 10-6 10z" />
      <circle cx="12" cy="11" r="2.5" />
    </svg>
  ),

  lender: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={iconClassName}
    >
      <path d="M7 3h7l5 5v13H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z" />
      <path d="M14 3v5h5" />
      <circle cx="10" cy="10" r="1" />
      <circle cx="14" cy="16" r="1" />
      <path d="M15.5 8.5l-7 9" />
    </svg>
  ),

  valuation: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={iconClassName}
    >
      <circle cx="11" cy="11" r="5" />
      <path d="M20 20l-4.2-4.2" />
      <path d="M11 8v6" />
      <path d="M8 11h6" />
    </svg>
  ),

  diamond: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={iconClassName}
    >
      <path d="M7 4h10l4 5-9 11L3 9l4-5z" />
      <path d="M3 9h18" />
      <path d="M9 4l3 5 3-5" />
    </svg>
  ),

  returns: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={iconClassName}
    >
      <rect x="3" y="5" width="18" height="16" rx="2" />
      <path d="M8 3v4" />
      <path d="M16 3v4" />
      <path d="M3 10h18" />
      <path d="M8 15h8" />
    </svg>
  ),

  release: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={iconClassName}
    >
      <rect x="4" y="11" width="16" height="10" rx="2" />
      <path d="M8 11V8a4 4 0 0 1 7.5-2" />
      <path d="M14 6h4v4" />
      <path d="M18 6l-5 5" />
    </svg>
  ),

  rewards: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={iconClassName}
    >
      <path d="M12 22V12" />
      <path d="M4 7h16v5H4z" />
      <path d="M6 22h12V12H6z" />
      <path d="M12 7V4" />
      <path d="M9.5 4.5A2.5 2.5 0 0 1 12 7H8a2 2 0 1 1 1.5-2.5z" />
      <path d="M14.5 4.5A2.5 2.5 0 0 0 12 7h4a2 2 0 1 0-1.5-2.5z" />
    </svg>
  ),

  users: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={iconClassName}
    >
      <circle cx="9" cy="8" r="3" />
      <circle cx="17" cy="10" r="2.5" />
      <path d="M3.5 19a5.5 5.5 0 0 1 11 0" />
      <path d="M14 19a4 4 0 0 1 7 0" />
    </svg>
  ),

  tracking: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={iconClassName}
    >
      <path d="M4 18h16" />
      <path d="M6 15l4-4 3 2 5-6" />
      <circle cx="6" cy="15" r="1" />
      <circle cx="10" cy="11" r="1" />
      <circle cx="13" cy="13" r="1" />
      <circle cx="18" cy="7" r="1" />
    </svg>
  ),

  support: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={iconClassName}
    >
      <path d="M4 12a8 8 0 0 1 16 0" />
      <rect x="3" y="12" width="4" height="6" rx="1" />
      <rect x="17" y="12" width="4" height="6" rx="1" />
      <path d="M7 18a5 5 0 0 0 10 0" />
    </svg>
  ),

  expert: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={iconClassName}
    >
      <circle cx="10" cy="8" r="3" />
      <path d="M4 19a6 6 0 0 1 12 0" />
      <path d="M18 7l.8 1.6 1.7.2-1.2 1.2.3 1.7L18 11l-1.6.7.3-1.7-1.2-1.2 1.7-.2L18 7z" />
    </svg>
  ),

  installment: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={iconClassName}
    >
      <rect x="3" y="4" width="18" height="17" rx="2" />
      <path d="M8 2v4" />
      <path d="M16 2v4" />
      <path d="M3 10h18" />
      <path d="M8 14h3" />
      <path d="M13 14h3" />
      <path d="M8 17h8" />
    </svg>
  ),

  clock: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={iconClassName}
    >
      <circle cx="12" cy="12" r="8" />
      <path d="M12 8v5l3 2" />
    </svg>
  ),

  wallet: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={iconClassName}
    >
      <path d="M3 7a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v1H5a2 2 0 0 0 0 4h13v5a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7z" />
      <path d="M18 8h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2z" />
      <circle cx="17" cy="10" r=".5" fill="currentColor" stroke="none" />
    </svg>
  ),

  percent: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={iconClassName}
    >
      <path d="M19 5L5 19" />
      <circle cx="7.5" cy="7.5" r="2.5" />
      <circle cx="16.5" cy="16.5" r="2.5" />
    </svg>
  ),

  auction: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={iconClassName}
    >
      <path d="M14 6l4 4" />
      <path d="M9 11l7-7 4 4-7 7" />
      <path d="M7 13l4 4" />
      <path d="M3 21h8" />
    </svg>
  ),

  unlock: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={iconClassName}
    >
      <rect x="4" y="11" width="16" height="9" rx="2" />
      <path d="M8 11V8a4 4 0 0 1 7 2" />
    </svg>
  ),

  sparkle: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={iconClassName}
    >
      <path d="M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8L12 3z" />
    </svg>
  ),
};

const serviceItemIconMap = {
  "Old Gold Jewellery": serviceIcons.valuation,
  "Broken or Damaged Gold": serviceIcons.shield,
  "Gold Coins & Bars": serviceIcons.pricing,
  "Scrap Gold Jewellery": serviceIcons.document,
  "Gold Jewellery with Stones": serviceIcons.diamond,

  "Safe and Secure Doorstep Service": serviceIcons.shield,
  "Transparent Purity and Weight Testing": serviceIcons.purity,
  "Live Market Based Gold Pricing": serviceIcons.pricing,
  "Instant Payment After Evaluation": serviceIcons.payment,
  "No Hidden Charges or Obligations": serviceIcons.document,

  "Step 1: Visit Any G1 Gold Branch": serviceIcons.branch,
  "Step 2: Coordination with Lender": serviceIcons.lender,
  "Step 3: Verification & Testing": serviceIcons.purity,
  "Step 4: Transparent Valuation": serviceIcons.valuation,
  "Step 5: Instant Payment": serviceIcons.payment,

  "Step 1: Bring Your Jewellery": serviceIcons.branch,
  "Step 2: Jewellery Assessment": serviceIcons.valuation,
  "Step 3: Stone Evaluation": serviceIcons.diamond,
  "Step 4: Transparent Price Breakdown": serviceIcons.document,
  "Step 5: Instant Payout": serviceIcons.payment,

  "Step 1: Visit Any G1 Branch": serviceIcons.branch,
  "Step 2: Purity & Valuation": serviceIcons.purity,
  "Step 3: Rental Agreement": serviceIcons.document,
  "Step 4: Receive Monthly Returns": serviceIcons.returns,
  "Step 5: Return Gold at End of Term": serviceIcons.release,

  "Step 1: Visit Our Branch": serviceIcons.branch,
  "Step 2: Loan & Interest Review": serviceIcons.lender,
  "Step 3: Interest Payment Assistance": serviceIcons.support,
  "Step 4: Gold Verification": serviceIcons.purity,
  "Step 5: Smooth Settlement": serviceIcons.release,

  "Earn Rewards for Every Successful Referral": serviceIcons.rewards,
  "No Cap on the Number of Referrals": serviceIcons.users,
  "Quick and Hassle Free Reward Credit": serviceIcons.payment,
  "Simple and Transparent Referral Tracking": serviceIcons.tracking,
  "Anyone Can Participate": serviceIcons.users,

  "Step 1: Bring Your Pledged Gold Details": serviceIcons.branch,
  "Step 2: Loan Settlement Review": serviceIcons.lender,
  "Step 3: Choose Your Installment Plan": serviceIcons.installment,
  "Step 4: Complete Documentation": serviceIcons.document,
  "Step 5: Get Your Gold Released": serviceIcons.release,

  "Step 1: Bring Your Gold Jewellery": serviceIcons.branch,
  "Step 2: Gold Evaluation": serviceIcons.valuation,
  "Step 3: Loan & Cash Disbursement": serviceIcons.payment,
  "Step 4: Interest Benefit Period": serviceIcons.clock,
  "Step 5: Repayment & Gold Release": serviceIcons.release,

  "Accurate Purity and Weight Testing": serviceIcons.purity,
  "Professional Evaluation by Trained Experts": serviceIcons.expert,
  "Transparent Valuation Explanation": serviceIcons.document,
  "Fair Assessment Based on Live Gold Rates": serviceIcons.pricing,
  "Clear Documentation and Report if Required": serviceIcons.document,
  "Safe and Secure Handling of Jewellery": serviceIcons.shield,

  "Transparent Jewellery Testing": serviceIcons.purity,
  "Stone Value Consideration": serviceIcons.diamond,
  "Market Based Valuation": serviceIcons.pricing,
  "Professional Documentation": serviceIcons.document,
  "Trusted Experts": serviceIcons.expert,

  "Has Gold Pledged Due to Financial Needs": serviceIcons.wallet,
  "Wants to Avoid Escalating Interest Charges": serviceIcons.percent,
  "Wishes to Prevent Gold from Going to Auction": serviceIcons.auction,
  "Wants to Unlock the Value of Their Gold Without Delay": serviceIcons.unlock,
};

const getServiceItemIcon = (title = "", description = "") => {
  if (serviceItemIconMap[title]) return serviceItemIconMap[title];

  const text = `${title} ${description}`.toLowerCase();

  if (
    text.includes("financial need") ||
    text.includes("financial needs") ||
    text.includes("urgent financial") ||
    text.includes("money need") ||
    text.includes("cash need")
  ) {
    return serviceIcons.wallet;
  }

  if (
    text.includes("interest charge") ||
    text.includes("interest charges") ||
    text.includes("escalating interest") ||
    text.includes("prevent increasing interest") ||
    text.includes("interest costs")
  ) {
    return serviceIcons.percent;
  }

  if (
    text.includes("auction") ||
    text.includes("lender auction") ||
    text.includes("prevent gold from going to auction")
  ) {
    return serviceIcons.auction;
  }

  if (
    text.includes("unlock the value") ||
    text.includes("unlock value") ||
    text.includes("without delay") ||
    text.includes("quickly and easily")
  ) {
    return serviceIcons.unlock;
  }

  if (
    text.includes("stone") ||
    text.includes("diamond") ||
    text.includes("jewellery with stones")
  ) {
    return serviceIcons.diamond;
  }

  if (
    text.includes("expert") ||
    text.includes("trained") ||
    text.includes("experienced") ||
    text.includes("appraiser") ||
    text.includes("professional evaluation")
  ) {
    return serviceIcons.expert;
  }

  if (text.includes("referral") || text.includes("reward")) {
    if (text.includes("tracking")) return serviceIcons.tracking;
    if (
      text.includes("participate") ||
      text.includes("many people") ||
      text.includes("number of referrals")
    ) {
      return serviceIcons.users;
    }
    if (text.includes("credit")) return serviceIcons.payment;
    return serviceIcons.rewards;
  }

  if (
    text.includes("installment") ||
    text.includes("repayment plan") ||
    text.includes("monthly payment")
  ) {
    return serviceIcons.installment;
  }

  if (
    text.includes("interest benefit period") ||
    text.includes("interest period") ||
    text.includes("monthly returns") ||
    text.includes("benefit period") ||
    text.includes("period")
  ) {
    return serviceIcons.clock;
  }

  if (
    text.includes("documentation") ||
    text.includes("document") ||
    text.includes("paperwork") ||
    text.includes("agreement") ||
    text.includes("report") ||
    text.includes("hidden charges") ||
    text.includes("obligations") ||
    text.includes("price breakdown")
  ) {
    return serviceIcons.document;
  }

  if (
    text.includes("release") ||
    text.includes("returned to you") ||
    text.includes("gold released") ||
    text.includes("return gold") ||
    text.includes("smooth settlement")
  ) {
    return serviceIcons.release;
  }

  if (
    text.includes("payment") ||
    text.includes("payout") ||
    text.includes("cash") ||
    text.includes("bank transfer") ||
    text.includes("credit")
  ) {
    return serviceIcons.payment;
  }

  if (
    text.includes("market") ||
    text.includes("gold rates") ||
    text.includes("pricing") ||
    text.includes("valuation based") ||
    text.includes("live gold")
  ) {
    return serviceIcons.pricing;
  }

  if (
    text.includes("purity") ||
    text.includes("weight testing") ||
    text.includes("verification") ||
    text.includes("testing") ||
    text.includes("jewellery testing")
  ) {
    return serviceIcons.purity;
  }

  if (
    text.includes("valuation") ||
    text.includes("evaluation") ||
    text.includes("assessment")
  ) {
    return serviceIcons.valuation;
  }

  if (
    text.includes("safe and secure") ||
    text.includes("secure handling") ||
    text.includes("doorstep") ||
    text.includes("safely")
  ) {
    return serviceIcons.shield;
  }

  if (
    text.includes("visit") ||
    text.includes("branch") ||
    text.includes("bring your jewellery") ||
    text.includes("bring your gold")
  ) {
    return serviceIcons.branch;
  }

  if (
    text.includes("lender") ||
    text.includes("loan review") ||
    text.includes("settlement review") ||
    text.includes("coordination") ||
    text.includes("loan settlement")
  ) {
    return serviceIcons.lender;
  }

  if (text.includes("assistance") || text.includes("support")) {
    return serviceIcons.support;
  }

  return serviceIcons.sparkle;
};

const serviceImageMap = {

  "convert-old-gold-to-new-gold": [
  "/images/service/convert-old-gold-to-new-gold-0.webp",
  "/images/service/convert-old-gold-to-new-gold-2.webp",
  "/images/service/convert-old-gold-to-new-gold-3.webp",
],
  "sell-gold-for-cash": [
    "/images/service/sell-gold-for-cash-0.webp",
    "/images/service/sell-gold-for-cash-2.webp",
    "/images/service/sell-gold-for-cash-3.webp",
  ],
"sell-gold-from-home": [
  "/images/service/sell-gold-from-home-0.webp",
  "/images/service/sell-gold-from-home-2.webp",
  "/images/service/sell-gold-from-home-3.webp",
],
  "release-pledged-gold": [
    "/images/service/release-pledged-gold-0.webp",
    "/images/service/release-pledged-gold-2.webp",
    "/images/service/release-pledged-gold-3.webp",
  ],
  "stone-value-for-your-gold": [
    "/images/service/stone-value-for-your-gold-0.webp",
    "/images/service/stone-value-for-your-gold-2.webp",
    "/images/service/stone-value-for-your-gold-3.webp",
  ],


  "refer-and-earn": [
    "/images/service/refer-and-earn-0.webp",
    "/images/service/refer-and-earn-2.webp",
    "/images/service/refer-and-earn-3.webp",
  ],
 
  "golden-period-scheme": [
    "/images/service/golden-period-scheme-0.webp",
    "/images/service/golden-period-scheme-2.webp",
    "/images/service/golden-period-scheme-3.webp",
  ],

};
const serviceImageAltMap = {

  "convert-old-gold-to-new-gold": [
  "Convert old gold to new gold with G1 Gold",
  "Old gold to new gold exchange support at G1 Gold",
  "Gold jewellery upgrade support at G1 Gold",
],
  "sell-gold-for-cash": [
    "Woman holding cash after selling gold jewellery at G1 Gold in Bangalore",
    "Jewellery for selling at G1 Gold in Bangalore",
    "Gold bars and coins for selling at G1 Gold in Bangalore",
  ],
 

  "release-pledged-gold": [
    "Woman presenting gold loan support to release pledged gold in Bangalore.",
    "Release Pledged Gold in Bangalore with Easy Loan Closure",
    "Release pledged gold service with gold jewellery and instant cash",
  ],
 
  "sell-gold-from-home": [
    "Sell gold from home service promotional image",
    "Sell gold from home service with gold weighing and payment success",
    "Sell gold from home service with jewellery purity checking",
  ],
  
 
  "stone-value-for-your-gold": [
    "Representative explaining stone value for gold ornaments",
    "Stone value for gold jewellery with gemstone inspection",
    "Stone value for gold jewellery consultation",
  ],
  "refer-and-earn": [
    "Refer and earn promotional image",
    "Refer and earn cash reward service",
    "Refer and earn service with cash rewards and gift benefits",
  ],
};
const ogMetaMap = {
 
"convert-old-gold-to-new-gold": {
  title: "Convert Old Gold to New Gold | G1 Gold",
  description:
    "Sell your old gold for high value and use the instant payment to buy new gold jewellery with transparent testing and trusted service.",
  image: "https://g1gold.com/images/service/convert-old-gold-to-new-gold-0.webp",
  imageAlt: "Convert old gold to new gold with G1 Gold",
},

 "refer-and-earn": {
  title: "Refer and Earn Gold Rewards | G1 Gold Referral Program",
  description:
    "Refer friends and earn exciting rewards. Share our trusted gold services and enjoy referral benefits when your friends complete transactions.",
   image: "https://g1gold.com/images/service/refer-and-earn-0.webp",
},
  "release-pledged-gold": {
    title: "Release Pledged Gold in Bangalore | Close Gold Loan Easily",
    description:
      "Release pledged gold easily with our trusted gold loan closure service. Clear your loan, recover your jewellery safely, and enjoy a transparent process.",
      image: "https://g1gold.com/images/service/release-pledged-gold-0.webp",
  },

  

"sell-gold-for-cash": {
  title: "Sell Gold for Cash in Bangalore | Get Instant Payment",
  description:
    "Sell gold for cash with trusted gold buyers offering instant payment, transparent purity testing, and the best market price for your gold jewellery.",
  image: "https://g1gold.com/images/service/sell-gold-for-cash-og.jpg",
  imageAlt: "Woman holding cash after selling gold jewellery at G1 Gold in Bangalore",
},

  "sell-gold-from-home": {
    title: "Sell Gold from Home | Doorstep Gold Buyers in Bangalore",
    description:
      "Sell gold at your doorstep with secure home service. Get transparent purity testing, fair valuation, and instant payment from trusted gold buyers.",
    image: "https://g1gold.com/images/service/sell-gold-from-home-0.webp",
  },

  "stone-value-for-your-gold": {
    title: "Stone Value in Gold Jewellery | Know Actual Gold Price",
    description:
      "Understand stone value when selling gold jewellery. Get transparent gold valuation where stones are assessed separately for fair pricing.",
    image: "https://g1gold.com/images/service/stone-value-for-your-gold-0.webp",
  },

  

  "golden-period-scheme": {
    title: "Golden Period Scheme in Bangalore | 21 Days Interest-Free Plan",
    description:
      "Join the Golden Period Scheme and save regularly for gold purchases. Enjoy flexible payments, secure savings, and exclusive benefits.",
    image: "https://g1gold.com/images/service/golden-period-scheme-0.webp",
  },
};
const defaultDocumentsRequired = [
  "Valid Government Issued ID Proof",
  "Address Proof",
  "Gold Purchase Invoice if Available",
  "One Passport Size Photo",
];

const defaultDocumentsImages = [
  `${process.env.PUBLIC_URL}/images/service/Gold-purchase.png`,
  `${process.env.PUBLIC_URL}/images/service/Original-pledged.png`,
  `${process.env.PUBLIC_URL}/images/service/Address-proof.webp`,
  `${process.env.PUBLIC_URL}/images/service/One-passport.png`,
];

const documentsImageMap = {
  "release-pledged-gold": [
    `${process.env.PUBLIC_URL}/images/service/Gold-purchase.png`,
    `${process.env.PUBLIC_URL}/images/service/Original-pledged.png`,
    `${process.env.PUBLIC_URL}/images/service/Address-proof.webp`,
    `${process.env.PUBLIC_URL}/images/service/One-passport.png`,
  ],
};

const fallbackImages = [
  "/images/service/home1.webp",
  "/images/service/home1.webp",
  "/images/service/home1.webp",
];

const goldGradient = {
  background: "linear-gradient(135deg, #C89B2B 0%, #F2D36A 100%)",
};

const primaryButtonStyle = {
  background: "linear-gradient(135deg, #EFCB57 0%, #C89B2B 100%)",
};

const getDocumentCardImage = (doc = "", slug, index = 0) => {
  const text = doc.toLowerCase();

if (
  text.includes("aadhaar") ||
  text.includes("pan") ||
  text.includes("voter") ||
  text.includes("government issued id") ||
  text.includes("id proof")
) {
  return `${process.env.PUBLIC_URL}/images/service/ValidgovernmentissuedIDproof.png`;
}

if (text.includes("address")) {
  return `${process.env.PUBLIC_URL}/images/service/Address-proof.webp`;
}

  if (
  text.includes("stone") ||
  text.includes("stones") ||
  text.includes("jewellery containing stones") ||
  text.includes("jewelry containing stones")
) {
return `${process.env.PUBLIC_URL}/images/service/Gold-purchase.png`;
}

  if (
    text.includes("invoice") ||
    text.includes("gold purchase")
  ) {
 return `${process.env.PUBLIC_URL}/images/service/Gold-purchase.png`;
  }

  if (
    text.includes("original pledged") ||
    text.includes("pledged gold receipt") ||
    text.includes("loan documentation") ||
    text.includes("loan documents")
  ) {
   return `${process.env.PUBLIC_URL}/images/service/Original-pledged.png`;
  }

  if (
    text.includes("passport") ||
    text.includes("photo")
  ) {
   return `${process.env.PUBLIC_URL}/images/service/One-passport.png`;
  }

  const documentsImages = documentsImageMap[slug] || defaultDocumentsImages;
  return documentsImages[index] || documentsImages[0];
};

const CountUpNumber = ({ end, suffix = "", decimals = 0, duration = 4200 }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let startTime = null;
    let animationFrame;

    const animate = (currentTime) => {
      if (!startTime) startTime = currentTime;

      const progress = Math.min((currentTime - startTime) / duration, 1);
      const easeOut = 1 - Math.pow(1 - progress, 3);

      setCount(end * easeOut);

      if (progress < 1) {
        animationFrame = requestAnimationFrame(animate);
      }
    };

    animationFrame = requestAnimationFrame(animate);

    return () => cancelAnimationFrame(animationFrame);
  }, [end, duration]);

  const formattedNumber =
    decimals > 0
      ? count.toFixed(decimals)
      : Math.floor(count).toLocaleString("en-IN");

  return (
    <>
      {formattedNumber}
      {suffix}
    </>
  );
};
const getServiceIconSizeClass = (serviceSlug) => {
  const sizeMap = {
    "sell-gold-for-cash": "h-[100px] w-[100px]",
    "sell-gold-from-home": "h-[100px] w-[100px]",
    "release-pledged-gold": "h-[100px] w-[100px]",
    "stone-value-for-your-gold": "h-[100px] w-[100px]",
    "refer-and-earn": "h-[100px] w-[100px]",
  };

  return sizeMap[serviceSlug] || "h-[100px] w-[100px]";
};
const otherServiceIconMap = {
  "sell-gold-for-cash": serviceIcons.payment,
  "sell-gold-from-home": serviceIcons.shield,
  "release-pledged-gold": serviceIcons.release,
  "convert-old-gold-to-new-gold": serviceIcons.sparkle,
  "stone-value-for-your-gold": serviceIcons.diamond,
  "refer-and-earn": serviceIcons.rewards,
};
const ReleasePledgedGoldProcessDesign = ({
  serviceImages = [],
}) => {
  const getImagePath = (path) => {
    if (!path) return "";
    if (path.startsWith("http")) return path;
    return `${process.env.PUBLIC_URL}${path.startsWith("/") ? path : `/${path}`}`;
  };

  const imageSrc =
    getImagePath(serviceImages?.[1]) ||
    getImagePath(serviceImages?.[2]) ||
    getImagePath(serviceImages?.[0]) ||
    `${process.env.PUBLIC_URL}/images/service/release-pledged-gold-2.webp`;

  const steps = [
    {
      title: "Share Pledge Details",
      description:
        "Provide your pledged gold loan details and our experts will review them.",
    },
    {
      title: "Release Coordination",
      description:
        "We coordinate with your bank or NBFC to start the gold release process.",
    },
    {
      title: "Purity and Weight Check",
      description:
        "Once received, your gold is carefully tested for purity and accurately weighed.",
    },
    {
      title: "Final Value Confirmation",
      description:
        "You receive a transparent valuation based on current market rates.",
    },
    {
      title: "Instant Payment",
      description:
        "Accept the offer and get instant payment transferred securely to your account.",
    },
  ];

  return (
<section className="relative overflow-hidden bg-[#07152b] py-12 sm:py-14 lg:py-16">
  {/* premium background */}
  <div className="pointer-events-none absolute -left-32 top-8 h-[360px] w-[360px] rounded-full bg-[#d7a51f]/10 blur-[110px]" />
  <div className="pointer-events-none absolute right-0 bottom-0 h-[420px] w-[420px] rounded-full bg-[#f4d16b]/8 blur-[130px]" />
  <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_18%_20%,rgba(244,209,107,0.08),transparent_28%),radial-gradient(circle_at_88%_70%,rgba(215,165,31,0.08),transparent_30%)]" />

  <div className="relative mx-auto max-w-[1380px] px-4 sm:px-6 lg:px-10">
    <div className="grid gap-10 lg:grid-cols-2 lg:items-center xl:gap-12">
      
      {/* LEFT PROCESS */}
      <div className="flex h-full w-full flex-col justify-center lg:min-h-[560px]">
        <p className="text-[10px] font-extrabold uppercase tracking-[0.34em] text-[#f4d16b] sm:text-[11px]">
          Simple Process
        </p>

        <h2 className="mt-4 max-w-[560px] text-[28px] font-extrabold leading-[1.15] tracking-[-0.02em] text-white sm:text-[36px] lg:text-[42px]">
          How the Pledged Gold{" "}
          <span className="text-[#f4c542]">Release Process Works</span>
        </h2>

        <div className="mt-5 flex items-center gap-2">
          <span className="h-px w-24 bg-[#d7a51f]" />
          <span className="h-2 w-2 rotate-45 bg-[#d7a51f]" />
          <span className="h-px w-24 bg-[#d7a51f]" />
        </div>

        <div className="relative mt-8 space-y-4">
          <div className="absolute left-[22px] top-8 hidden h-[calc(100%-58px)] w-px bg-gradient-to-b from-[#d7a51f] via-[#d7a51f]/60 to-transparent sm:block" />

          {steps.map((step, index) => (
            <article
              key={index}
              className="group relative grid grid-cols-[48px_1fr] gap-4 sm:grid-cols-[54px_1fr]"
            >
              <div className="relative z-10 flex h-11 w-11 items-center justify-center rounded-full bg-gradient-to-br from-[#f4d16b] to-[#c89214] text-[15px] font-extrabold text-[#07152b] shadow-[0_12px_28px_rgba(244,209,107,0.22)] transition-all duration-300 group-hover:scale-105 sm:h-12 sm:w-12">
                {index + 1}
              </div>

              <div className="rounded-[16px] border border-white/10 bg-white/[0.04] px-4 py-4 shadow-[0_12px_30px_rgba(0,0,0,0.16)] transition-all duration-300 group-hover:border-[#d7a51f]/40 group-hover:bg-white/[0.06]">
                <h3 className="text-[16px] font-extrabold leading-snug text-[#f4c542] sm:text-[17px]">
                  {step.title}
                </h3>

                <p className="mt-1.5 max-w-[430px] text-[13.5px] font-medium leading-6 text-[#eaf0f8] sm:text-[14px]">
                  {step.description}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>

     {/* RIGHT IMAGE */}
<div className="relative flex h-full w-full items-start justify-center lg:min-h-[560px] lg:pt-[280px]">
  <div className="relative flex h-[300px] w-full max-w-[780px] items-center justify-center bg-transparent p-0 sm:h-[390px] lg:h-[430px] xl:h-[455px]">
    <img
  src={`${process.env.PUBLIC_URL}/images/service/pledged.webp`}
  alt="Release gold jewellery from loan in Bangalore with pledged gold release form."
  className="block h-full w-full scale-[1.35] object-contain object-center"
  onError={(e) => {
    e.currentTarget.onerror = null;
    e.currentTarget.src = `${process.env.PUBLIC_URL}/images/service/release-pledged-gold-2.webp`;
  }}
/>
  </div>
</div>

    </div>
   </div>
</section>

  );
};
const ReleasePledgedGoldComparisonTable = () => {
  const comparisonOptions = [
    {
      title: "Repay loan directly",
      whatHappens: "Pay lender and collect gold",
      bestFor: "Customers who have funds available",
      benefit: "Quick closure and full recovery of jewellery",
      icon: serviceIcons.lender,
    },
    {
      title: "Part-payment",
      whatHappens: "Reduce outstanding balance if lender permits",
      bestFor: "Customers seeking partial repayment",
      benefit: "Reduces interest burden and keeps account active",
      icon: serviceIcons.document,
    },
    {
      title: "Loan renewal",
      whatHappens: "Continue loan under lender's terms",
      bestFor: "Customers who want to retain the loan",
      benefit: "More time to repay with flexible tenure",
      icon: serviceIcons.clock,
    },
    {
      title: "Release and sell",
      whatHappens: "Settle loan, receive gold, then sell",
      bestFor: "Customers considering selling jewellery",
      benefit: "Convert gold into cash after settling the loan",
      icon: serviceIcons.valuation,
    },
  ];

  return (
    <section className="relative overflow-hidden bg-[#fffdf8] py-10 sm:py-12 lg:py-14">

      <div className="pointer-events-none absolute -left-32 top-10 h-[300px] w-[300px] rounded-full bg-[#f4d16b]/12 blur-[100px]" />

      <div className="relative mx-auto max-w-[1450px] px-4 sm:px-6 lg:px-10">

        {/* TITLE */}
        <div className="mb-7 text-center">
          <h2 className="text-[22px] font-extrabold leading-tight text-[#07152B] sm:text-[28px] lg:text-[32px]">
            Gold Loan Repayment and Release Options Compared
          </h2>

          <div className="mx-auto mt-3 h-[3px] w-12 rounded-full bg-[#d8a018]" />
        </div>

{/* DESKTOP TABLE */}
<div className="hidden overflow-hidden rounded-[28px] border border-[#E8C96B] bg-white shadow-[0_18px_45px_rgba(20,33,61,0.06)] md:block">

  {/* HEADER */}
  <div className="grid grid-cols-[1fr_1.05fr_1fr]">

    <div className="flex min-h-[68px] items-center justify-center border-r border-[#E8D6A0] bg-white px-5">
      <h3 className="text-center text-[18px] font-extrabold text-[#07152B]">
        Option
      </h3>
    </div>

    <div className="flex min-h-[68px] items-center justify-center border-r border-[#E8D6A0] bg-[#F7F7F8] px-5">
      <h3 className="text-center text-[18px] font-extrabold text-[#07152B]">
        What Happens
      </h3>
    </div>

    <div className="flex min-h-[68px] items-center justify-center bg-[#E5A80B] px-5">
      <h3 className="text-center text-[18px] font-extrabold text-white">
        Best Suited For
      </h3>
    </div>

  </div>

  {/* ROWS */}
  {comparisonOptions.map((item, index) => (
    <div
      key={index}
      className="grid grid-cols-[1fr_1.05fr_1fr] border-t border-[#EADDB9]"
    >

      {/* OPTION */}
      <div className="flex min-h-[82px] items-center gap-4 border-r border-[#EADDB9] bg-white px-6 py-3">

        <span className="flex h-[48px] w-[48px] shrink-0 items-center justify-center rounded-full border border-[#E7C34F] bg-[#FFF9E9] text-[#D99A00] shadow-[0_6px_18px_rgba(213,157,16,0.08)]">
          <span className="[&_svg]:h-5 [&_svg]:w-5">
            {item.icon}
          </span>
        </span>

        <span className="text-[16px] font-extrabold leading-5 text-[#07152B]">
          {item.title}
        </span>

      </div>

      {/* WHAT HAPPENS */}
      <div className="flex min-h-[82px] items-center border-r border-[#EADDB9] bg-[#FAFAFB] px-6 py-3">

        <p className="text-[15px] font-medium leading-6 text-[#34445E]">
          {item.whatHappens}
        </p>

      </div>
{/* BEST SUITED FOR */}
<div className="flex min-h-[82px] items-center gap-4 bg-[#FFF9E8] px-6 py-3">

  {/* GREEN ROUND TICK */}
  <span className="flex h-[38px] w-[38px] shrink-0 items-center justify-center rounded-full bg-[#28B84A] text-white shadow-[0_8px_20px_rgba(40,184,74,0.20)]">
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="h-5 w-5"
    >
      <path d="M5 12l4 4L19 7" />
    </svg>
  </span>

  {/* TEXT */}
  <p className="text-[15px] font-medium leading-6 text-[#07152B]">
    {item.bestFor}
  </p>

</div>

    </div>
  ))}

</div>


{/* MOBILE CARDS */}
<div className="grid gap-4 md:hidden">

  {comparisonOptions.map((item, index) => (
    <article
      key={index}
      className="rounded-[14px] border border-[#e5d5aa] bg-white p-5 shadow-[0_10px_28px_rgba(20,33,61,0.07)]"
    >

      <div className="flex items-center gap-3">

        <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full border border-[#91c8b8] bg-[#edf8f4] text-[#16705b]">
          <span className="[&_svg]:h-6 [&_svg]:w-6">
            {item.icon}
          </span>
        </span>

        <h3 className="text-[17px] font-extrabold leading-snug text-[#07152B]">
          {item.title}
        </h3>

      </div>

      <div className="mt-5 space-y-4">

        {/* WHAT HAPPENS */}
        <div>
          <p className="text-[11px] font-extrabold uppercase tracking-[0.05em] text-[#b9820b]">
            What Happens
          </p>

          <p className="mt-1.5 text-[14px] font-medium leading-6 text-[#475569]">
            {item.whatHappens}
          </p>
        </div>

        {/* BEST SUITED FOR */}
        <div>
          <p className="text-[11px] font-extrabold uppercase tracking-[0.05em] text-[#b9820b]">
            Best Suited For
          </p>

          <p className="mt-1.5 text-[14px] font-medium leading-6 text-[#475569]">
            {item.bestFor}
          </p>
        </div>

      </div>

    </article>
  ))}

</div>

        {/* MOBILE CARDS */}
        <div className="grid gap-4 md:hidden">

          {comparisonOptions.map((item, index) => (
            <article
              key={index}
              className="rounded-[14px] border border-[#e5d5aa] bg-white p-5 shadow-[0_10px_28px_rgba(20,33,61,0.07)]"
            >

              <div className="flex items-center gap-3">

                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-[#91c8b8] bg-[#edf8f4] text-[#16705b]">
                  <span className="[&_svg]:h-6 [&_svg]:w-6">
                    {item.icon}
                  </span>
                </span>

                <h3 className="text-[15px] font-extrabold text-[#07152B]">
                  {item.title}
                </h3>

              </div>

              <div className="mt-4 space-y-3">

                <div>
                  <p className="text-[10px] font-extrabold uppercase text-[#b9820b]">
                    What Happens
                  </p>
                  <p className="mt-1 text-[13px] leading-5 text-[#475569]">
                    {item.whatHappens}
                  </p>
                </div>

                <div>
                  <p className="text-[10px] font-extrabold uppercase text-[#b9820b]">
                    Best Suited For
                  </p>
                  <p className="mt-1 text-[13px] leading-5 text-[#475569]">
                    {item.bestFor}
                  </p>
                </div>

                <div>
                  <p className="text-[10px] font-extrabold uppercase text-[#b9820b]">
                    Key Benefit
                  </p>
                  <p className="mt-1 text-[13px] leading-5 text-[#475569]">
                    {item.benefit}
                  </p>
                </div>

              </div>
            </article>
          ))}

        </div>

      </div>
    </section>
  );
};
const StoneValueHeroProcessDesign = ({ serviceImages = [] }) => {
  const getImagePath = (path) => {
    if (!path) return "";
    if (path.startsWith("http")) return path;
    return `${process.env.PUBLIC_URL}${path.startsWith("/") ? path : `/${path}`}`;
  };

  const imageSrc =
    getImagePath(serviceImages?.[0]) ||
    getImagePath(serviceImages?.[1]) ||
    getImagePath(serviceImages?.[2]) ||
    `${process.env.PUBLIC_URL}/images/service/stone-value-for-your-gold-0.webp`;

  const highlights = [
    {
      title: "Stone Checking",
      description: "We check eligible stones carefully and explain their value clearly.",
      icon: (
        <svg viewBox="0 0 24 24" className="h-8 w-8" fill="none" stroke="currentColor" strokeWidth="1.7">
          <path d="M7 4h10l4 5-9 11L3 9l4-5z" />
          <path d="M3 9h18" />
          <path d="M9 4l3 5 3-5" />
          <path d="M12 9v11" />
        </svg>
      ),
    },
    {
      title: "Gold Valuation",
      description: "Gold purity and weight are tested properly for fair value.",
      icon: (
        <svg viewBox="0 0 24 24" className="h-8 w-8" fill="none" stroke="currentColor" strokeWidth="1.7">
          <path d="M12 3v18" />
          <path d="M5 7h14" />
          <path d="M7 7l-3 6a3 3 0 0 0 6 0L7 7z" />
          <path d="M17 7l-3 6a3 3 0 0 0 6 0l-3-6z" />
        </svg>
      ),
    },
    {
      title: "Quick Payment",
      description: "After confirmation, you receive fast and secure payment.",
      icon: (
        <svg viewBox="0 0 24 24" className="h-8 w-8" fill="none" stroke="currentColor" strokeWidth="1.7">
          <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" />
          <path d="M14 3v5h5" />
          <path d="M9 14l2 2 4-4" />
        </svg>
      ),
    },
  ];

  return (
  <section className="relative overflow-hidden bg-[#fffdf7] py-12 sm:py-14 lg:py-16">
  <div className="pointer-events-none absolute -left-32 top-10 h-[340px] w-[340px] rounded-full bg-[#f4d16b]/18 blur-[110px]" />
  <div className="pointer-events-none absolute right-0 bottom-0 h-[380px] w-[380px] rounded-full bg-[#c89214]/10 blur-[120px]" />

  <div className="relative mx-auto max-w-[1520px] px-4 sm:px-6 lg:px-12">
    <div className="mx-auto grid max-w-[1380px] items-center gap-8 lg:grid-cols-[0.95fr_1.05fr] lg:gap-12 xl:gap-14">
      
      {/* LEFT IMAGE */}
      <div className="relative flex w-full items-center justify-center lg:min-h-[560px]">
        <div className="pointer-events-none absolute -inset-4 rounded-[28px] bg-[#d7a51f]/12 blur-2xl" />

        <div className="relative h-[320px] w-full overflow-hidden rounded-[24px] border border-[#e5c76f]/60 bg-[#f7edda] shadow-[0_28px_75px_rgba(20,33,61,0.14)] sm:h-[420px] lg:h-[520px]">
          <img
  src={`${process.env.PUBLIC_URL}/images/service/stone.webp`}
  alt="Stone value for gold jewellery evaluation"
  className="h-full w-full object-cover object-center"
  onError={(e) => {
    e.currentTarget.onerror = null;
    e.currentTarget.src = `${process.env.PUBLIC_URL}/images/service/stone-value-for-your-gold-0.webp`;
  }}
/>

          <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-[#081225]/18 via-transparent to-transparent" />
        </div>
      </div>

      {/* RIGHT CONTENT */}
      <div className="flex w-full flex-col justify-center rounded-[26px] px-0 py-2 lg:min-h-[560px] lg:px-2">
        <p className="text-[11px] font-extrabold uppercase tracking-[0.36em] text-[#b98512]">
          Our Process
        </p>

        <h2 className="mt-5 max-w-[690px] text-[26px] font-extrabold leading-[1.18] tracking-[-0.02em] text-[#081225] sm:text-[32px] lg:text-[38px] xl:text-[42px]">
          Get Stone Value for Gold Jewellery Through a Simple and Transparent Process
        </h2>

        <p className="mt-6 max-w-[650px] text-[15px] font-medium leading-7 text-[#253149] sm:text-[16px] sm:leading-8">
          G1 Gold helps you get the right stone value in gold jewellery through a clear and trusted process. Our experts check the gold purity, weight, and eligible stones carefully before explaining the final value. We make sure you understand how your jewellery is valued, including the gold price and stone value. If your jewellery has valuable stones, we provide fair support instead of ignoring them. With G1 Gold, you can get stone value in gold jewellery with transparency, fair pricing, and quick payment.
        </p>

        <div className="mt-8 grid gap-5 sm:grid-cols-3">
          {highlights.map((item, index) => (
            <div
              key={index}
              className={`text-center ${
                index !== 0 ? "sm:border-l sm:border-[#d7a51f]/35" : ""
              }`}
            >
              <div className="mx-auto flex h-[60px] w-[60px] items-center justify-center rounded-full border border-[#e5c76f] bg-white text-[#d7a51f] shadow-[0_10px_26px_rgba(215,165,31,0.10)]">
                {item.icon}
              </div>

              <h3 className="mx-auto mt-4 max-w-[180px] text-[15px] font-extrabold leading-snug text-[#081225]">
                {item.title}
              </h3>

              <p className="mx-auto mt-3 max-w-[180px] text-[12.5px] font-medium leading-5 text-[#4b5563]">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>

    </div>
  </div>
</section>
  );
};
const StoneValueSellingProcessDesign = ({ serviceImages = [] }) => {
  const getImagePath = (path) => {
    if (!path) return "";
    if (path.startsWith("http")) return path;
    return `${process.env.PUBLIC_URL}${path.startsWith("/") ? path : `/${path}`}`;
  };

  const imageSrc =
    getImagePath(serviceImages?.[1]) ||
    getImagePath(serviceImages?.[2]) ||
    getImagePath(serviceImages?.[0]) ||
    `${process.env.PUBLIC_URL}/images/service/stone-value-for-your-gold-2.webp`;

  const steps = [
    {
      number: "01",
      title: "Share Jewellery Details",
      description:
        "Tell us about your jewellery with stones, diamonds, or embedded pieces.",
    },
    {
      number: "02",
      title: "Purity & Weight Check",
      description:
        "We test the gold purity and measure the total jewellery weight clearly.",
    },
    {
      number: "03",
      title: "Separate Stone Evaluation",
      description:
        "Our experts identify and value each stone, diamond, or embedded piece individually.",
    },
    {
      number: "04",
      title: "Value Breakup Provided",
      description:
        "You receive a clear breakup of gold value and stone value for better understanding.",
    },
    {
      number: "05",
      title: "Instant Payment",
      description:
        "Once you agree, payment is made instantly through your preferred mode.",
    },
  ];

  return (
    <section className="relative overflow-hidden bg-[#fffdf7] py-12 sm:py-14 lg:py-16">
      <div className="pointer-events-none absolute -left-32 top-6 h-[320px] w-[320px] rounded-full bg-[#f4d16b]/16 blur-[110px]" />
      <div className="pointer-events-none absolute -right-36 bottom-0 h-[380px] w-[380px] rounded-full bg-[#c89214]/10 blur-[120px]" />

      <div className="relative mx-auto max-w-[1520px] px-4 sm:px-6 lg:px-12">
        <div className="grid items-stretch gap-8 lg:grid-cols-[0.92fr_1.08fr] lg:gap-12 xl:gap-14">
          
          {/* LEFT PROCESS */}
          <div className="flex w-full flex-col justify-center lg:min-h-[500px]">
            <p className="text-[10px] font-extrabold uppercase tracking-[0.34em] text-[#b98512] sm:text-[11px]">
              Our Process
            </p>

            <h2 className="mt-4 max-w-[560px] text-[26px] font-extrabold leading-[1.18] tracking-[-0.02em] text-[#081225] sm:text-[32px] lg:text-[38px]">
              How the Stone Value Selling Process Works
            </h2>

            <div className="mt-6 space-y-3">
              {steps.map((step, index) => (
                <article
                  key={index}
                  className="group flex items-start gap-4 rounded-[14px] border border-[#ead8a8]/70 bg-white/82 px-4 py-3 shadow-[0_10px_28px_rgba(20,33,61,0.045)] transition-all duration-300 hover:-translate-y-0.5 hover:border-[#d7a51f] hover:shadow-[0_16px_38px_rgba(198,146,24,0.10)] sm:px-5 sm:py-4"
                >
                  <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-[#e6b22a] to-[#c48605] text-[13px] font-extrabold text-white shadow-[0_10px_22px_rgba(198,134,5,0.22)]">
                    {step.number}
                  </div>

                  <div className="min-w-0">
                    <h3 className="text-[15px] font-extrabold leading-snug text-[#081225] sm:text-[16px]">
                      {step.title}
                    </h3>

                    <p className="mt-1 text-[13px] font-medium leading-5 text-[#3c465c] sm:text-[13.5px]">
                      {step.description}
                    </p>
                  </div>
                </article>
              ))}
            </div>
          </div>

          {/* RIGHT IMAGE */}
         {/* RIGHT IMAGE */}
{/* RIGHT IMAGE */}
<div className="relative flex w-full items-center justify-center lg:min-h-[500px]">
  <div className="relative flex h-[300px] w-full items-center justify-center overflow-visible bg-transparent p-0 sm:h-[400px] lg:h-full">
    <img
      src={`${process.env.PUBLIC_URL}/images/service/stone-value.webp`}
      alt="Stone value selling process for gold jewellery"
      className="h-full w-full scale-[0.85] object-contain object-center"
    />
  </div>
</div>
         

        </div>
      </div>
    </section>
  );
};
const ReferAndEarnProcessDesign = () => {
  const steps = [
    {
      number: "1",
      title: "Refer Someone You Know",
      description:
        "Share your referral link or recommend our services to friends, family members, or colleagues who want to sell gold.",
      icon: serviceIcons.users,
    },
    {
      number: "2",
      title: "They Complete a Gold Transaction",
      description:
        "Your referred person visits us and successfully completes their gold transaction through our transparent process.",
      icon: serviceIcons.document,
    },
    {
      number: "3",
      title: "You Receive Your Reward",
      description:
        "Once the transaction is completed, your referral reward is credited. The more you refer, the more you earn.",
      icon: serviceIcons.rewards,
    },
  ];

  return (
 <section className="relative overflow-hidden bg-[#fffdf7] py-10 sm:py-12 lg:py-14">
  <div className="pointer-events-none absolute -left-32 top-10 h-[300px] w-[300px] rounded-full bg-[#f4d16b]/18 blur-[100px]" />
  <div className="pointer-events-none absolute -right-32 bottom-0 h-[330px] w-[330px] rounded-full bg-[#c89214]/10 blur-[110px]" />

  <div className="relative mx-auto max-w-[1400px] px-4 sm:px-6 lg:px-10">
    <div className="mb-8 text-center lg:text-left">
      <p className="text-[9px] font-extrabold uppercase tracking-[0.32em] text-[#b98512] sm:text-[10px]">
        Service Details
      </p>

      <h2 className="mt-4 max-w-[820px] text-[25px] font-extrabold leading-[1.16] tracking-[-0.02em] text-[#081225] sm:text-[32px] lg:text-[38px] xl:text-[44px]">
        How the Refer & Earn Program Works
      </h2>
    </div>

    <div className="relative">
      {/* Desktop timeline line */}
      <div className="pointer-events-none absolute left-8 right-8 top-[38px] hidden h-[2px] bg-gradient-to-r from-[#d7a51f] via-[#e6b22a] to-[#d7a51f] lg:block" />

      <div className="relative grid gap-6 md:grid-cols-3 lg:gap-8">
        {steps.map((step, index) => (
          <article key={index} className="relative">
            {/* Number circle */}
            <div className="relative z-10 mx-auto flex h-[56px] w-[56px] items-center justify-center rounded-full bg-gradient-to-br from-[#e9b735] to-[#c88a08] text-[20px] font-extrabold text-white shadow-[0_12px_26px_rgba(200,138,8,0.25)] lg:h-[62px] lg:w-[62px]">
              {step.number}
            </div>

            {/* small connector line for desktop */}
            <div className="mx-auto hidden h-9 w-px bg-[#d7a51f]/45 lg:block" />

            <div className="group min-h-[245px] rounded-[22px] border border-[#ead8a8]/70 bg-white/78 px-5 py-6 text-center shadow-[0_18px_45px_rgba(20,33,61,0.07)] transition-all duration-300 hover:-translate-y-1 hover:border-[#d7a51f] hover:shadow-[0_24px_60px_rgba(198,146,24,0.12)] sm:px-6 lg:px-8 lg:py-8">
              <div className="mx-auto flex h-[58px] w-[58px] items-center justify-center rounded-full bg-gradient-to-br from-[#e9b735] to-[#c88a08] text-white shadow-[0_12px_26px_rgba(200,138,8,0.20)] transition-all duration-300 group-hover:scale-105">
                <span className="[&_svg]:h-7 [&_svg]:w-7">
                  {step.icon}
                </span>
              </div>

              <h3 className="mx-auto mt-5 max-w-[250px] text-[18px] font-extrabold leading-snug tracking-[0.02em] text-[#081225] sm:text-[20px]">
                {step.title}
              </h3>

              <p className="mx-auto mt-4 max-w-[310px] text-[13px] font-medium leading-6 text-[#2f3b52] sm:text-[14px]">
                {step.description}
              </p>
            </div>
          </article>
        ))}
      </div>
    </div>
  </div>
</section>
  );
};
const ReferAndEarnJoinBenefitsDesign = ({ serviceImages = [] }) => {
  const getImagePath = (path) => {
    if (!path) return "";
    if (path.startsWith("http")) return path;
    return `${process.env.PUBLIC_URL}${path.startsWith("/") ? path : `/${path}`}`;
  };

  const imageSrc =
    getImagePath(serviceImages?.[1]) ||
    getImagePath(serviceImages?.[2]) ||
    getImagePath(serviceImages?.[0]) ||
    `${process.env.PUBLIC_URL}/images/service/refer-and-earn-2.webp`;

  const benefits = [
    {
      title: "Earn Rewards for Every Successful Referral",
      description:
        "Get rewarded every time someone you refer completes a successful transaction with us.",
      icon: serviceIcons.rewards,
    },
    {
      title: "No Cap on the Number of Referrals",
      description:
        "Refer as many people as you like and keep earning without limits or restrictions.",
      icon: serviceIcons.users,
    },
    {
      title: "Quick and Hassle-Free Reward Credit",
      description:
        "Your rewards are credited quickly after a successful referral, with no complicated process.",
      icon: serviceIcons.payment,
    },
    {
      title: "Simple and Transparent Referral Tracking",
      description:
        "Track your referrals easily and stay updated on their status through a clear process.",
      icon: serviceIcons.tracking,
    },
    {
      title: "Anyone Can Participate",
      description:
        "Anyone can join the program and start earning rewards with no special requirements.",
      icon: serviceIcons.users,
    },
  ];

  return (
    <section className="relative overflow-hidden bg-[#071225] py-12 sm:py-14 lg:py-16">
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_12%_18%,rgba(244,209,107,0.10),transparent_30%),radial-gradient(circle_at_85%_72%,rgba(215,165,31,0.08),transparent_34%)]" />
      <div className="pointer-events-none absolute -left-40 top-10 h-[420px] w-[420px] rounded-full bg-[#d7a51f]/10 blur-[130px]" />
      <div className="pointer-events-none absolute -right-40 bottom-0 h-[460px] w-[460px] rounded-full bg-[#f4d16b]/8 blur-[140px]" />

      <div className="relative mx-auto max-w-[1600px] px-4 sm:px-6 lg:px-12">
        <div className="grid items-stretch gap-10 lg:grid-cols-[1.05fr_0.95fr] xl:gap-14">
          
          {/* LEFT CONTENT */}
          <div className="flex w-full flex-col justify-center lg:min-h-[620px]">
            <div className="mb-8">
              <p className="text-[10px] font-extrabold uppercase tracking-[0.34em] text-[#f4c542] sm:text-[11px]">
                Service Details
              </p>

              <h2 className="mt-4 max-w-[760px] text-[28px] font-extrabold leading-[1.16] tracking-[-0.02em] text-white sm:text-[34px] lg:text-[40px] xl:text-[44px]">
                Why Join Our Refer & Earn Program?
              </h2>

              <div className="mt-5 h-[2px] w-24 rounded-full bg-[#d7a51f]" />
            </div>

            <div className="grid gap-5 sm:grid-cols-2 xl:grid-cols-3">
              {benefits.map((item, index) => (
                <article
                  key={index}
                  className={`group rounded-[18px] border border-white/16 bg-white/[0.035] px-5 py-5 shadow-[0_18px_45px_rgba(0,0,0,0.18)] transition-all duration-300 hover:-translate-y-1 hover:border-[#d7a51f]/55 hover:bg-white/[0.055] ${
                    index === 3 ? "xl:col-span-1" : ""
                  }`}
                >
                  <div className="flex h-[54px] w-[54px] items-center justify-center rounded-[14px] border border-[#d7a51f]/70 bg-[#d7a51f]/10 text-[#f4c542] transition-all duration-300 group-hover:scale-105 group-hover:bg-[#d7a51f]/18">
                    <span className="[&_svg]:h-7 [&_svg]:w-7">
                      {item.icon}
                    </span>
                  </div>

                  <h3 className="mt-5 max-w-[280px] text-[16px] font-extrabold leading-snug tracking-[0.01em] text-white sm:text-[17px]">
                    {item.title}
                  </h3>

                  <p className="mt-3 max-w-[310px] text-[13px] font-medium leading-6 text-[#e8eefb] sm:text-[13.5px]">
                    {item.description}
                  </p>
                </article>
              ))}
            </div>
          </div>

          {/* RIGHT IMAGE */}
       {/* RIGHT IMAGE */}
<div className="relative flex w-full items-center justify-center lg:min-h-[620px]">
  <div className="relative flex h-[320px] w-full items-end justify-center overflow-visible bg-transparent sm:h-[460px] lg:h-[560px]">
    <img
      src={`${process.env.PUBLIC_URL}/images/service/refer (2).webp`}
      alt="Refer and earn rewards program"
      className="h-full w-full scale-[1.35] object-contain object-bottom"
      onError={(e) => {
        e.currentTarget.onerror = null;
        e.currentTarget.src = `${process.env.PUBLIC_URL}/images/service/refer-and-earn-2.webp`;
      }}
    />
  </div>
</div>
        </div>
      </div>
    </section>
  );
};
const ConvertOldGoldValueSection = () => {
  return (
    <section className="bg-white py-14 sm:py-16 lg:py-20">
      <div className="mx-auto max-w-[1500px] px-4 sm:px-6 lg:px-12">
        <div className="overflow-hidden rounded-[28px] border border-[#ead8a8] bg-[#fffdf8] shadow-[0_18px_55px_rgba(20,33,61,0.08)]">
          <div className="grid items-center gap-10 p-6 sm:p-8 lg:grid-cols-2 lg:p-12">
            
            {/* LEFT CONTENT */}
            <div>
              <h2 className="max-w-[650px] text-[28px] font-bold leading-tight text-[#081225] sm:text-[36px] lg:text-[42px]">
                Turn Your Old Gold Value into{" "}
                <span className="text-[#c89214]">New Jewellery</span>
              </h2>

              <p className="mt-6 max-w-[650px] text-[15px] font-medium leading-8 text-[#34405a] sm:text-[16px]">
                Old gold does not lose its importance just because the design is
                outdated, broken, or unused. At G1 Gold, we help you get the
                right value for your old gold through clear purity checking,
                live gold rate calculation, and instant payment.
              </p>

              <p className="mt-5 max-w-[650px] text-[15px] font-medium leading-8 text-[#34405a] sm:text-[16px]">
                Once you receive the amount, you can use it to purchase new gold
                jewellery from any jewellery shop of your choice. This gives you
                the freedom to upgrade your old ornaments into new designs
                without depending on exchange offers or limited jewellery
                options.
              </p>
            </div>

         {/* RIGHT IMAGE */}
<div className="relative flex items-end justify-center">

  <img
    src={`${process.env.PUBLIC_URL}/images/service/Turn-your.webp`}
    alt="Convert old gold value into new jewellery at G1 Gold"
    className="h-[320px] w-full object-contain object-bottom sm:h-[420px] lg:h-[500px]"
    style={{
      WebkitMaskImage:
        "linear-gradient(to top, transparent 0%, black 12%, black 100%)",
      maskImage:
        "linear-gradient(to top, transparent 0%, black 12%, black 100%)",
    }}
    loading="lazy"
    onError={(e) => {
      e.currentTarget.onerror = null;
      e.currentTarget.src = `${process.env.PUBLIC_URL}/images/service/home1.webp`;
    }}
  />

</div>

          </div>
        </div>
      </div>
    </section>
  );
};





const ConvertOldGoldWhyChooseSection = () => {
  const cards = [
    {
      title: "Best Value for Old Gold",
      description:
        "We offer highest market value for your old gold based on live rates and accurate purity testing.",
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
          <path d="M12 3l2.2 4.4 4.8.7-3.5 3.4.8 4.8L12 14l-4.3 2.3.8-4.8L5 8.1l4.8-.7L12 3z" />
          <path d="M8 18l-1 3 5-2 5 2-1-3" />
        </svg>
      ),
    },
    {
      title: "Transparent Gold Testing",
      description:
        "Your gold is tested in front of you using advanced equipment for complete transparency.",
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
          <circle cx="11" cy="11" r="6" />
          <path d="M20 20l-4.2-4.2" />
          <path d="M9 11h4" />
          <path d="M11 9v4" />
        </svg>
      ),
    },
    {
      title: "Instant Payment",
      description:
        "Get your payment instantly via UPI, bank transfer, or cash as per your preference.",
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
          <path d="M13 2L4 14h7l-1 8 10-13h-7l1-7z" />
        </svg>
      ),
    },
    {
      title: "Freedom to Buy Anywhere",
      description:
        "Use the money to buy new jewellery from G1 Gold or any jewellery brand or store of your choice.",
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
          <path d="M6 8h12l1 13H5L6 8z" />
          <path d="M9 8a3 3 0 0 1 6 0" />
        </svg>
      ),
    },
    {
      title: "No Limited Exchange Conditions",
      description:
        "No pressure to buy from specific collections or pay making charges on exchange like offers.",
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
          <path d="M17 2l4 4-4 4" />
          <path d="M3 11V9a3 3 0 0 1 3-3h15" />
          <path d="M7 22l-4-4 4-4" />
          <path d="M21 13v2a3 3 0 0 1-3 3H3" />
        </svg>
      ),
    },
    {
      title: "Trusted Gold Selling Experience",
      description:
        "Thousands of happy customers trust G1 Gold for honest service, fair value, and complete satisfaction.",
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
          <path d="M12 3l7 3v6c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6l7-3z" />
          <path d="M9 12l2 2 4-4" />
        </svg>
      ),
    },
  ];

  return (
    <section className="bg-[#fffaf0] py-12 sm:py-14 lg:py-16">
      <div className="mx-auto max-w-[1450px] px-4 sm:px-6 lg:px-12">
        <div className="mx-auto mb-9 max-w-4xl text-center">
          <h2 className="text-[25px] font-bold leading-tight text-[#081225] sm:text-[32px] lg:text-[38px]">
            Why Choose G1 Gold to Convert Old Gold to New Gold?
          </h2>

          <div className="mx-auto mt-4 flex items-center justify-center gap-2">
            <span className="h-px w-20 bg-[#d7a51f]" />
            <span className="h-2 w-2 rotate-45 bg-[#d7a51f]" />
            <span className="h-px w-20 bg-[#d7a51f]" />
          </div>
        </div>

        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {cards.map((card, index) => (
            <article
              key={index}
              className="group rounded-2xl border border-[#ead8a8] bg-white p-5 shadow-[0_12px_35px_rgba(20,33,61,0.06)] transition-all duration-300 hover:-translate-y-1 hover:border-[#d7a51f] hover:shadow-[0_18px_45px_rgba(198,146,20,0.12)] sm:p-6"
            >
              <div className="flex gap-4">
                <div className="flex h-16 w-16 shrink-0 items-center justify-center rounded-full border border-[#ead8a8] bg-[#fff8e8] text-[#c89214] transition-all duration-300 group-hover:bg-[#c89214] group-hover:text-white [&_svg]:h-8 [&_svg]:w-8">
                  {card.icon}
                </div>

                <div>
                  <h3 className="text-[16px] font-extrabold leading-snug text-[#081225] sm:text-[17px]">
                    {card.title}
                  </h3>

                  <p className="mt-2 text-[13.5px] font-medium leading-6 text-[#46536b] sm:text-[14px]">
                    {card.description}
                  </p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};



const ConvertOldGoldWhoCanUseSection = () => {
  const users = [
    {
      title: "People with old or unused gold",
      description:
        "If you have gold jewellery that you no longer wear, you can sell it and use the value to buy new designs.",
    },
    {
      title: "Customers with broken gold jewellery",
      description:
        "Broken chains, damaged rings, old bangles, or unused ornaments can still give you good cash value.",
    },
    {
      title: "Anyone looking to upgrade jewellery designs",
      description:
        "If your current gold designs are outdated, you can convert their value into cash and purchase modern jewellery.",
    },
    {
      title: "Families planning to buy new gold",
      description:
        "You can sell old gold first, receive instant payment, and use that amount to reduce the cost of buying new jewellery.",
    },
    {
      title: "Customers who do not want limited exchange options",
      description:
        "Instead of depending on one shop’s exchange offer, you get cash value from G1 Gold and freedom to buy anywhere.",
    },
  ];

  return (
<section className="relative overflow-hidden bg-[#07152b] py-10 sm:py-12 lg:py-14">

  {/* ===================== LUXURY GOLD BACKGROUND ===================== */}

  {/* CENTER GOLD SPOTLIGHT */}
  <div className="pointer-events-none absolute left-1/2 top-1/2 h-[700px] w-[700px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[radial-gradient(circle,rgba(200,146,20,0.25)_0%,rgba(244,209,107,0.12)_35%,transparent_70%)] blur-[50px]" />

  {/* TOP LEFT GLOW */}
  <div className="pointer-events-none absolute -left-52 -top-44 h-[520px] w-[520px] rounded-full bg-[radial-gradient(circle,rgba(244,209,107,0.28)_0%,transparent_70%)] blur-[140px]" />

  {/* BOTTOM RIGHT GLOW */}
  <div className="pointer-events-none absolute -right-56 bottom-0 h-[580px] w-[580px] rounded-full bg-[radial-gradient(circle,rgba(200,146,20,0.22)_0%,transparent_70%)] blur-[160px]" />

  {/* LIGHT STREAK */}
  <div className="pointer-events-none absolute inset-0 bg-[linear-gradient(135deg,transparent_40%,rgba(244,209,107,0.07)_50%,transparent_60%)]" />

  {/* SUBTLE DARK TEXTURE */}
  <div className="pointer-events-none absolute inset-0 opacity-[0.05] [background-image:radial-gradient(#ffffff_1px,transparent_1px)] [background-size:22px_22px]" />

  {/* ===================== CONTENT WRAPPER ===================== */}
  <div className="relative mx-auto max-w-[1200px] px-4 sm:px-6 lg:px-10">

    <div className="relative p-0 sm:p-2 lg:p-3">

      {/* TOP CONTENT */}
      <div className="mx-auto mb-6 max-w-[820px] text-center">

       

        <h2 className="mt-4 text-[26px] font-bold leading-tight text-white sm:text-[34px] lg:text-[40px]">
          Who Can Use G1 Gold{" "}
          <span className="text-[#f4d16b]">
            Old Gold to New Gold Service?
          </span>
        </h2>

        <p className="mx-auto mt-5 max-w-[720px] text-[14px] font-medium leading-7 text-gray-300 sm:text-[15px]">
          G1 Gold’s Old Gold to New Gold Service is for anyone who wants to
          sell their old, unused, broken, or outdated gold for instant cash
          and use that amount to buy new gold jewellery from any shop of
          their choice.
        </p>

      </div>

      {/* GRID */}
    <div className="grid gap-6 lg:grid-cols-[1.1fr_0.9fr] lg:items-center">

        {/* LEFT */}
        <div>
          <div className="mt-6 grid gap-4">

            {users.map((item, index) => (
              <article
                key={index}
                className="group rounded-[20px] border border-white/10 bg-white/5 p-4 shadow-[0_12px_30px_rgba(0,0,0,0.35)] backdrop-blur-xl transition-all duration-300 hover:-translate-y-1 hover:border-[#f4d16b]/40 hover:shadow-[0_18px_45px_rgba(244,209,107,0.15)]"
              >
                <div className="flex gap-4">

                  <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-gradient-to-br from-[#f4d16b] to-[#c89214] text-[15px] font-extrabold text-black shadow-md">
                    {index + 1}
                  </div>

                  <div>
                    <h3 className="text-[16px] font-extrabold text-white">
                      {item.title}
                    </h3>

                    <p className="mt-1 text-[13.5px] leading-6 text-gray-300">
                      {item.description}
                    </p>
                  </div>

                </div>
              </article>
            ))}

          </div>
        </div>

    {/* RIGHT */}
<div className="relative flex items-center justify-center lg:justify-end">
  <div className="pointer-events-none absolute h-[420px] w-[420px] rounded-full bg-[#f4d16b]/25 blur-[95px]" />
<picture className="relative z-10 block w-full max-w-[520px] scale-105 transition-transform duration-300 sm:max-w-[560px] md:scale-[1.18] lg:max-w-[620px]">
  {/* Mobile image only */}
  <source
    media="(max-width: 767px)"
    srcSet={`${process.env.PUBLIC_URL}/images/service/convert-old-gold-to-new-gold-2-mobile.webp`}
  />

  {/* Desktop image stays same */}
  <img
    src={`${process.env.PUBLIC_URL}/images/service/convert-old-gold-to-new-gold-2.webp`}
    alt="Old Gold to New Gold Service"
    className="w-full object-contain"
    style={{
      WebkitMaskImage:
        "linear-gradient(to top, transparent 0%, black 10%, black 100%)",
      maskImage:
        "linear-gradient(to top, transparent 0%, black 10%, black 100%)",
    }}
  />
</picture>
</div>

      </div>

    </div>
  </div>
</section>
  );
};
const ConvertOldGoldHowItWorksSection = () => {
  const steps = [
    {
      title: "Bring Your Old Gold",
      description:
        "Bring your old, unused, broken, or outdated gold jewellery to G1 Gold for a clear value check.",
    },
    {
      title: "Get Live Purity Testing",
      description:
        "Our team checks the purity and weight in front of you using a transparent gold testing process.",
    },
    {
      title: "Receive the Best Cash Value",
      description:
        "We calculate your gold value based on purity, weight, and live gold rate, then explain the final amount clearly.",
    },
    {
      title: "Get Instant Payment",
      description:
        "Once you approve the value, you receive quick payment directly through a safe payment method.",
    },
  ];

  return (
<section className="relative overflow-hidden py-14 sm:py-16 lg:py-20">
      <div className="pointer-events-none absolute -left-32 top-8 h-[360px] w-[360px] rounded-full bg-[#f4d16b]/22 blur-[120px]" />
      <div className="pointer-events-none absolute -right-32 bottom-0 h-[420px] w-[420px] rounded-full bg-[#c89214]/12 blur-[130px]" />

      <div className="relative mx-auto max-w-[1450px] px-4 sm:px-6 lg:px-12">
        <div className="overflow-hidden rounded-[34px] border border-[#ead8a8] bg-white shadow-[0_24px_75px_rgba(20,33,61,0.09)]">
          <div className="grid gap-10 p-6 sm:p-8 lg:grid-cols-[0.9fr_1.1fr] lg:p-12">
            
            {/* LEFT HEADING */}
            <div className="flex flex-col justify-center">
              <p className="text-[11px] font-extrabold uppercase tracking-[0.34em] text-[#b98512]">
                Simple Process
              </p>

              <h2 className="mt-5 max-w-[520px] text-[30px] font-bold leading-tight text-[#081225] sm:text-[38px] lg:text-[46px]">
                How It{" "}
                <span className="text-[#c89214]">Works</span>
              </h2>

              <p className="mt-5 max-w-[560px] text-[15px] font-medium leading-8 text-[#46536b] sm:text-[16px]">
                Convert your old gold value into instant cash through a clear,
                simple, and transparent process.
              </p>

              <div className="mt-8 hidden h-[3px] w-32 rounded-full bg-gradient-to-r from-[#c89214] to-[#f4d16b] lg:block" />
            </div>

            {/* RIGHT STEPS */}
            <div className="relative">
              <div className="absolute left-[23px] top-4 h-[calc(100%-28px)] w-px bg-gradient-to-b from-[#d7a51f] via-[#ead8a8] to-transparent" />

              <div className="space-y-6">
                {steps.map((step, index) => (
                  <article key={index} className="relative flex gap-5">
                    <div className="relative z-10 flex h-12 w-12 shrink-0 items-center justify-center rounded-full border border-[#e6c15d] bg-white shadow-[0_12px_28px_rgba(198,146,20,0.16)]">
                      <span className="flex h-8 w-8 items-center justify-center rounded-full bg-gradient-to-br from-[#f4d16b] to-[#c89214] text-[14px] font-extrabold text-white">
                        {index + 1}
                      </span>
                    </div>

                    <div className="pb-3">
                      <h3 className="text-[18px] font-extrabold leading-snug text-[#081225] sm:text-[20px]">
                        {step.title}
                      </h3>

                      <p className="mt-2 max-w-[720px] text-[14px] font-medium leading-7 text-[#46536b] sm:text-[15px]">
                        {step.description}
                      </p>
                    </div>
                  </article>
                ))}
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};





const documentBannerContentMap = {
  "sell-gold-for-cash": {
    title: "Want to Sell Gold for Cash?",
    description:
      "Keep your documents ready and complete your gold selling process with quick support and transparent guidance.",
    image: "/images/service/sell-gold-for-cash-2.webp",
    alt: "Sell gold for cash document support at G1 Gold",
    points: ["Quick response", "Transparent guidance", "Easy support"],
  },
  "sell-gold-from-home": {
    title: "Selling Gold From Home?",
    description:
      "Our team guides you with the required details before the doorstep gold evaluation process.",
    image: "/images/service/sell-gold-from-home-2.webp",
    alt: "Sell gold from home document support at G1 Gold",
    points: ["Doorstep support", "Safe process", "Clear valuation"],
  },
  "release-pledged-gold": {
    title: "Releasing Pledged Gold?",
    description:
      "Keep your pledge details ready so our team can help you with a smoother gold release process.",
    image: "/images/service/release-pledged-gold-2.webp",
    alt: "Release pledged gold document support at G1 Gold",
    points: ["Loan closure help", "Document guidance", "Quick support"],
  },
  "stone-value-for-your-gold": {
    title: "Checking Stone Value?",
    description:
      "Bring the required details to understand gold weight, stone value, and final jewellery valuation clearly.",
    image: "/images/service/stone-value-for-your-gold-2.webp",
    alt: "Stone value document support at G1 Gold",
    points: ["Stone checking", "Clear breakup", "Fair valuation"],
  },
  "refer-and-earn": {
    title: "Refer and Earn with G1 Gold",
    description:
      "Share the right details and complete the referral process smoothly with proper support from our team.",
    image: "/images/service/refer-and-earn-2.webp",
    alt: "Refer and earn document support at G1 Gold",
    points: ["Simple referral", "Reward support", "Easy tracking"],
  },
};
const documentContactContentMap = {
  "sell-gold-for-cash": {
    title: "Want to Sell Gold for Cash?",
    highlight: "Contact G1 Gold",
    description:
      "We make selling your gold simple, secure, and rewarding. Get in touch with us today for instant assistance.",
    serviceValue: "sell-gold-for-cash",
  },
  "sell-gold-from-home": {
    title: "Want to Sell Gold From Home?",
    highlight: "Contact G1 Gold",
    description:
      "Book a safe doorstep gold service and get clear guidance from our team before the process begins.",
    serviceValue: "sell-gold-from-home",
  },
  "release-pledged-gold": {
    title: "Want to Release Pledged Gold?",
    highlight: "Contact G1 Gold",
    description:
      "Get support to release your pledged gold with smooth coordination, clear process, and quick assistance.",
    serviceValue: "release-pledged-gold",
  },
  "stone-value-for-your-gold": {
    title: "Need Stone Value for Your Gold?",
    highlight: "Contact G1 Gold",
    description:
      "Understand your jewellery value clearly with transparent stone checking and fair gold valuation support.",
    serviceValue: "stone-value-for-your-gold",
  },
  "refer-and-earn": {
    title: "Want to Refer and Earn?",
    highlight: "Contact G1 Gold",
    description:
      "Refer your friends or family and get proper support to complete the referral process smoothly.",
    serviceValue: "refer-and-earn",
  },
};

const serviceOptions = [
  { value: "sell-gold-for-cash", label: "Sell Gold for Cash" },
  { value: "sell-gold-from-home", label: "Sell Gold From Home" },
  { value: "release-pledged-gold", label: "Release Pledged Gold" },
  { value: "stone-value-for-your-gold", label: "Stone Value For Your Gold" },
  { value: "refer-and-earn", label: "Refer and Earn" },
];

const getServiceDisplayName = (slug = "", serviceTitle = "") => {
  if (serviceTitle) return serviceTitle;

  const option = serviceOptions.find((item) => item.value === slug);
  if (option?.label) return option.label;

  return slug
    ?.split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

const DocumentsContactStrip = ({ slug, serviceTitle = "" }) => {
  const serviceName = getServiceDisplayName(slug, serviceTitle);

  const content =
    documentContactContentMap[slug] || {
      title: `Need Help with ${serviceName}?`,
      highlight: "Contact G1 Gold",
      description:
        "Get clear guidance from our team for your gold service requirement. We help you understand the process, required details, and next steps with proper support.",
      serviceValue: slug || "",
    };
const [goldValueFormLoading, setGoldValueFormLoading] = useState(false);
const [goldValueInlineTouched, setGoldValueInlineTouched] = useState(false);

const [goldValueInlineForm, setGoldValueInlineForm] = useState({
  name: "",
  mobile: "",
  service: content.serviceValue || "",
  message: "",
});

const isGoldValueInlineFormReady = useMemo(() => {
  const name = goldValueInlineForm.name.trim();
  const mobile = goldValueInlineForm.mobile.trim();
  const service = goldValueInlineForm.service;

  return (
    /^[A-Za-z]+(?:\s[A-Za-z]+)*$/.test(name) &&
    /^\d{10}$/.test(mobile) &&
    service !== ""
  );
}, [goldValueInlineForm]);

useEffect(() => {
  setGoldValueInlineForm({
    name: "",
    mobile: "",
    service: content.serviceValue || "",
    message: "",
  });


  setGoldValueInlineTouched(false);
}, [slug, content.serviceValue]);

const GOLD_VALUE_LEADS_SCRIPT_URL =
  "https://script.google.com/macros/s/AKfycbz1qxKRwtlJkUSO6R1lrs7o3cAAu-7nkfUVkRXA3gcupH4y88bfFbvKSmAGTVR5VH9O1w/exec";

const goldValueCtaLocationText = "Service Page";
const sanitizeOnlyLetters = (value) => {
  return value
    .replace(/[^A-Za-z\s]/g, "")
    .replace(/\s{2,}/g, " ")
    .replace(/^\s+/, "");
};

const sanitizeOnlyNumbers = (value) => {
  return value.replace(/\D/g, "").slice(0, 10);
};



const handleGoldValueInlineFormSubmit = async (e) => {
  e.preventDefault();

  if (goldValueFormLoading) return;

const name = goldValueInlineForm.name.trim();
const mobile = goldValueInlineForm.mobile.trim();
const service = goldValueInlineForm.service;
const message = goldValueInlineForm.message.trim();

if (!goldValueInlineTouched || !isGoldValueInlineFormReady) {
  alert("Please fill name, valid 10 digit mobile number, and service.");
  return;
}

  if (!name) {
    alert("Please enter your name.");
    return;
  }

  if (!/^[A-Za-z ]+$/.test(name)) {
    alert("Please enter a valid name. Only letters and spaces are allowed.");
    return;
  }

  if (!/^\d{10}$/.test(mobile)) {
    alert("Please enter a valid 10 digit mobile number.");
    return;
  }

  if (!service) {
    alert("Please select service required.");
    return;
  }

  const payload = {
    name: name,
    phoneNumber: mobile,
    source: service,
    message: message || "Need gold value assistance",
    location: goldValueCtaLocationText,
    pageUrl: window.location.href,
    formType: "Gold Value CTA Form",
    sheetName: "Gold Value Leads",
  };

  try {
    setGoldValueFormLoading(true);

    await fetch(GOLD_VALUE_LEADS_SCRIPT_URL, {
      method: "POST",
      mode: "no-cors",
      headers: {
        "Content-Type": "text/plain;charset=utf-8",
      },
      body: JSON.stringify(payload),
    });

alert("Submitted Successfully");

setGoldValueInlineForm({
  name: "",
  mobile: "",
  service: content.serviceValue || "",
  message: "",
});

setGoldValueInlineTouched(false);

  } catch (err) {
    console.error("Submit error:", err);
    alert("Submission failed. Please try again.");
  } finally {
    setGoldValueFormLoading(false);
  }
};


  return (
    <div 
    id="gold-value-contact-section"
className="scroll-mt-[120px] mb-14 overflow-hidden rounded-[26px] border border-[#ead8a8]/80 bg-[#fffdf7] shadow-[0_18px_55px_rgba(20,33,61,0.08)]">
      <div className="grid min-h-[360px] items-center gap-8 px-5 py-10 sm:px-8 sm:py-12 lg:grid-cols-[0.9fr_1.1fr] lg:px-12 lg:py-12">
        
        {/* Left Content */}
        <div>
          <h3 className="text-[26px] font-extrabold leading-tight tracking-wide text-[#081225] sm:text-[30px] lg:text-[34px]">
            {content.title}
            <br />
            <span className="text-[#d19a12]">{content.highlight}</span>
          </h3>

          <p className="mt-4 max-w-[520px] text-[13px] font-medium leading-6 text-[#2f3b52] sm:text-[14px]">
            {content.description}
          </p>

     <div className="mt-7 grid grid-cols-2 items-center gap-x-3 gap-y-4 sm:flex sm:flex-wrap sm:gap-x-8 sm:gap-y-4">
  {[
    "Quick response",
    "Easy support",
    "Transparent guidance",
  ].map((item, index) => (
    <div
      key={index}
      className={`flex items-center gap-2.5 ${
        index === 2
          ? "col-span-2 justify-center sm:col-span-1 sm:justify-start"
          : ""
      }`}
    >
      <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-[#fff4d7] text-[#c89214]">
        {index === 0 ? "◉" : index === 1 ? "♙" : "✦"}
      </span>

      <span className="whitespace-nowrap text-[12px] font-bold text-[#14213d]">
        {item}
      </span>
    </div>
  ))}
</div>

          <div className="mt-7 flex flex-col gap-3 sm:flex-row">
            <a
              href="tel:+91 7996 800 900"
              className="inline-flex min-h-[44px] items-center justify-center gap-2 rounded-full border border-[#ead8a8] bg-white px-6 text-[13px] font-extrabold text-[#081225] shadow-[0_8px_22px_rgba(20,33,61,0.06)] transition-all duration-300 hover:-translate-y-0.5 hover:border-[#d7a51f]"
            >
              <span className="text-[#c89214]">☎</span>
           +91 7996 800 900
            </a>

            <a
              href="https://wa.me/+917996800900"
              target="_blank"
              rel="noreferrer"
              className="inline-flex min-h-[44px] items-center justify-center gap-2 rounded-full border border-[#ead8a8] bg-white px-6 text-[13px] font-extrabold text-[#081225] shadow-[0_8px_22px_rgba(20,33,61,0.06)] transition-all duration-300 hover:-translate-y-0.5 hover:border-[#25d366]"
            >
              <span className="text-[#25d366]">●</span>
              Chat on WhatsApp
            </a>
          </div>
        </div>

        {/* Right Form */}
        <div className="rounded-[22px] border border-[#ead8a8]/80 bg-white px-5 py-7 shadow-[0_12px_35px_rgba(20,33,61,0.08)] sm:px-7 sm:py-8">
  <form
  onSubmit={handleGoldValueInlineFormSubmit}
  className="space-y-4"
  autoComplete="off"
>
            <div className="relative">
              <span className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-[13px] text-[#6b7280]">
                👤
              </span>
             <input
  type="text"
  name="name"
  placeholder="Your Name"
  maxLength={50}
  value={goldValueInlineForm.name}
  autoComplete="off"
onChange={(e) => {
  const value = e.target.value;

  setGoldValueInlineTouched(true);

  setGoldValueInlineForm((prev) => ({
    ...prev,
    name: sanitizeOnlyLetters(value),
  }));
}}
  className="h-[50px] w-full rounded-[10px] border border-[#e5e7eb] bg-white pl-11 pr-4 text-[13px] font-semibold text-[#14213d] outline-none transition focus:border-[#d7a51f] focus:ring-2 focus:ring-[#d7a51f]/15"
/>
            </div>

            <div className="relative">
              <span className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-[13px] text-[#6b7280]">
                ☎
              </span>
          <input
  type="tel"
  name="mobile"
  placeholder="Mobile Number"
  inputMode="numeric"
  maxLength={10}
  value={goldValueInlineForm.mobile}
  autoComplete="off"
onChange={(e) => {
  const value = e.target.value;

  setGoldValueInlineTouched(true);

  setGoldValueInlineForm((prev) => ({
    ...prev,
    mobile: sanitizeOnlyNumbers(value),
  }));
}}
  className="h-[50px] w-full rounded-[10px] border border-[#e5e7eb] bg-white pl-11 pr-4 text-[13px] font-semibold text-[#14213d] outline-none transition focus:border-[#d7a51f] focus:ring-2 focus:ring-[#d7a51f]/15"
/>
            </div>

            <div className="relative">
              <span className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-[13px] text-[#6b7280]">
                ▣
              </span>
             <select
  name="service"
  value={goldValueInlineForm.service}
onChange={(e) => {
  const value = e.target.value;

  setGoldValueInlineTouched(true);

  setGoldValueInlineForm((prev) => ({
    ...prev,
    service: value,
  }));
}}
  className="h-[50px] w-full appearance-none rounded-[10px] border border-[#e5e7eb] bg-white pl-11 pr-10 text-[13px] font-semibold text-[#14213d] outline-none transition focus:border-[#d7a51f] focus:ring-2 focus:ring-[#d7a51f]/15"
>
                <option value="">Service Required</option>
                {serviceOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>

              <span className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 text-[12px] text-[#6b7280]">
                ▼
              </span>
            </div>

            <div className="relative">
              <span className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-[13px] text-[#6b7280]">
                ✉
              </span>
        <input
  type="text"
  name="message"
  maxLength={120}
  value={goldValueInlineForm.message}
  autoComplete="off"
onChange={(e) => {
  const value = e.target.value;

  setGoldValueInlineTouched(true);

  setGoldValueInlineForm((prev) => ({
    ...prev,
    message: sanitizeOnlyLetters(value),
  }));
}}
  placeholder="Message (Optional)"
  className="h-[50px] w-full rounded-[10px] border border-[#e5e7eb] bg-white pl-11 pr-4 text-[13px] font-semibold text-[#14213d] outline-none transition focus:border-[#d7a51f] focus:ring-2 focus:ring-[#d7a51f]/15"
/>
            </div>

    <button
  type="submit"
disabled={
  goldValueFormLoading ||
  !goldValueInlineTouched ||
  !isGoldValueInlineFormReady
}
  className="mt-3 h-[56px] w-full rounded-[12px] bg-gradient-to-r from-[#e1aa18] to-[#c48705] text-[15px] font-extrabold text-white shadow-[0_12px_28px_rgba(196,135,5,0.28)] transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_16px_34px_rgba(196,135,5,0.35)] disabled:cursor-not-allowed disabled:opacity-70"
>
  {goldValueFormLoading ? "Submitting..." : "Get Gold Value Now"}
</button>
          </form>
        </div>
      </div>
    </div>
  );
};
const ServiceItemCards = ({ section, serviceImages = [], slug, serviceTitle = "" }) => {
  const getImagePath = (path) => {
    if (!path) return "";
    if (path.startsWith("http")) return path;
    return `${process.env.PUBLIC_URL}${path.startsWith("/") ? path : `/${path}`}`;
  };

  const visualImage =
    getImagePath(serviceImages?.[2]) ||
    getImagePath(serviceImages?.[1]) ||
    getImagePath(serviceImages?.[0]) ||
    `${process.env.PUBLIC_URL}/images/service/sell-gold-for-cash-3.webp`;

  const visualAlt =
    serviceImageAltMap?.[slug]?.[2] ||
    serviceImageAltMap?.[slug]?.[1] ||
    serviceImageAltMap?.[slug]?.[0] ||
    serviceTitle ||
    section.heading ||
    "Gold jewellery";
    const isSellGoldForCashPage = slug === "sell-gold-for-cash";

  return (
   <div
  className={`relative overflow-hidden rounded-[28px] px-4 py-5 sm:px-5 lg:px-6 ${
    isSellGoldForCashPage
      ? "border-0 bg-transparent shadow-none"
      : "border border-[#d7a51f]/25 bg-[#07152b] shadow-[0_20px_70px_rgba(0,0,0,0.28)]"
  }`}
>
      <style>
        {`
          @keyframes softShine {
            0% { transform: translateX(-140%) skewX(-18deg); opacity: 0; }
            35% { opacity: 0.22; }
            100% { transform: translateX(180%) skewX(-18deg); opacity: 0; }
          }


          @keyframes imageFloat {
            0%, 100% { transform: translateY(0px); }
            50% { transform: translateY(-6px); }
          }
        `}
      </style>

      {/* section glow */}
     {!isSellGoldForCashPage && (
  <>
    <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_78%_48%,rgba(244,209,107,0.12),transparent_32%),radial-gradient(circle_at_12%_18%,rgba(215,165,31,0.08),transparent_24%)]" />
    <div className="pointer-events-none absolute -left-16 top-12 h-[220px] w-[220px] rounded-full bg-[#d7a51f]/10 blur-[90px]" />
    <div className="pointer-events-none absolute right-8 top-1/2 h-[280px] w-[280px] -translate-y-1/2 rounded-full bg-[#f4d16b]/10 blur-[100px]" />
  </>
)}
      <div className="relative grid items-center gap-6 lg:grid-cols-[1.1fr_0.9fr]">
        {/* Left cards area */}
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-6">
          {section.items.map((item, itemIndex) => {
            const centerLastRow =
              section.items.length === 5 && itemIndex === 3 ? "xl:col-start-2" : "";

            return (
              <article
                key={itemIndex}
                className={`${centerLastRow} group relative min-h-[150px] overflow-hidden rounded-[18px] border border-white/10 bg-[linear-gradient(145deg,rgba(35,50,78,0.95),rgba(17,28,49,0.96))] shadow-[0_14px_35px_rgba(0,0,0,0.22)] transition-all duration-300 hover:-translate-y-1 hover:border-[#f4d16b]/45 xl:col-span-2`}
              >
                <div className="relative h-full overflow-hidden rounded-[18px] px-5 py-4">
                  {/* soft moving shine */}
                  <div
                    className="pointer-events-none absolute top-0 h-full w-16 bg-gradient-to-r from-transparent via-white/15 to-transparent"
                    style={{ animation: "softShine 5s ease-in-out infinite" }}
                  />

                

                  <div className="relative z-10">
                    <h3 className="text-[15px] font-bold leading-snug text-white sm:text-[16px]">
                      {item.title}
                    </h3>

                    <div className="mt-3 h-px w-full bg-gradient-to-r from-[#f4d16b]/70 via-white/10 to-transparent" />

                    <p className="mt-3 text-[12px] font-medium leading-6 text-[#e8eefb] sm:text-[12.5px]">
                      {item.description}
                    </p>
                  </div>
                </div>
              </article>
            );
          })}
        </div>

        {/* Right image area */}
     <div className="relative mx-auto w-full max-w-[560px]">
{!isSellGoldForCashPage && (
  <div className="pointer-events-none absolute inset-0 rounded-full bg-[#f4d16b]/10 blur-[80px]" />
)}

  <div className="relative z-10 scale-[1.25] sm:scale-[1.35] lg:scale-[1.48]">
    <img
      src={visualImage}
      alt={visualAlt}
      onError={(e) => {
        e.currentTarget.onerror = null;
        e.currentTarget.src = `${process.env.PUBLIC_URL}/images/service/sell-gold-for-cash-3.webp`;
      }}
      className="mx-auto h-[260px] w-full object-contain drop-shadow-[0_20px_45px_rgba(0,0,0,0.4)] sm:h-[320px] lg:h-[380px]"
      style={{ animation: "imageFloat 5s ease-in-out infinite" }}
    />
  </div>
</div>
      </div>
    </div>
  );
};
const SellGoldFromHomeHero = ({ serviceImages, serviceTitle }) => {
  const heroPoints = [
    {
      title: " gold evaluation",
      icon: "home",
    },
    {
      title: "Clear purity and weight checking",
      icon: "purity",
    },
    {
      title: "Instant payment after confirmation",
      icon: "payment",
    },
  ];

  const renderIcon = (type) => {
    if (type === "home") {
      return (
        <svg viewBox="0 0 24 24" className="h-9 w-9" fill="none" stroke="currentColor" strokeWidth="1.8">
          <path d="M4 11.5 12 4l8 7.5" />
          <path d="M6.5 10.5V20h11v-9.5" />
          <path d="M9.5 20v-5.5h5V20" />
          <circle cx="17.3" cy="17.2" r="1.6" />
        </svg>
      );
    }

    if (type === "purity") {
      return (
        <svg viewBox="0 0 24 24" className="h-9 w-9" fill="none" stroke="currentColor" strokeWidth="1.8">
          <path d="M12 3v18" />
          <path d="M5 7h14" />
          <path d="M7 7l-3 6a3 3 0 0 0 6 0L7 7z" />
          <path d="M17 7l-3 6a3 3 0 0 0 6 0l-3-6z" />
          <path d="M15 18l1.6 1.6L20 16" />
        </svg>
      );
    }

    return (
      <svg viewBox="0 0 24 24" className="h-9 w-9" fill="none" stroke="currentColor" strokeWidth="1.8">
        <path d="M4 7h16v11H4z" />
        <path d="M4 10h16" />
        <path d="M7 15h4" />
        <path d="M15 15l1.4 1.4L20 13" />
      </svg>
    );
  };

  return (
    <section className="relative overflow-hidden bg-[#fffdf6] px-4 py-8 sm:px-6 sm:py-10 lg:px-10 lg:py-12">
      <div className="pointer-events-none absolute -left-24 top-10 h-72 w-72 rounded-full bg-[#f4d16b]/20 blur-[100px]" />
      <div className="pointer-events-none absolute -right-24 bottom-8 h-80 w-80 rounded-full bg-[#c89214]/10 blur-[120px]" />

      <div className="relative mx-auto max-w-[1780px] rounded-[28px] border border-[#d7a51f] bg-[#fffdf7] px-5 py-8 shadow-[0_22px_70px_rgba(20,33,61,0.08)] sm:px-8 lg:rounded-[30px] lg:px-16 lg:py-16">
        <div className="grid items-center gap-10 lg:grid-cols-[0.88fr_1.12fr] xl:gap-16">
          {/* LEFT CONTENT */}
          <div className="mx-auto w-full max-w-[760px] text-center lg:mx-0 lg:text-left">
            <p className="text-[11px] font-extrabold uppercase tracking-[0.42em] text-[#b98512] sm:text-[13px]">
              Safe, Convenient, Trusted
            </p>

            <h1 className="mt-6 text-[34px] font-extrabold leading-[1.14] tracking-[0.02em] text-[#081225] sm:text-[44px] lg:text-[52px] xl:text-[60px]">
              Sell Gold from Home with a Safe and{" "}
              <span className="text-[#c89214]">Convenient Process</span>
            </h1>

            <p className="mt-7 text-[16px] font-medium leading-8 text-[#14213d] sm:text-[18px] sm:leading-9">
          With G1 Gold, you can sell gold from home without visiting a store or waiting in long queues. Our team comes to your location, checks the purity and weight of your gold in front of you, and explains the value clearly before you make a decision. The process is simple, private, and handled with complete care.
            </p>

            <p className="mt-7 text-[16px] font-medium leading-8 text-[#14213d] sm:text-[18px] sm:leading-9">
           Our sell gold at doorstep service is made for customers who want comfort, safety, and quick support. Whether you have old jewellery, unused gold, or need urgent cash, G1 Gold helps you sell gold from home with confidence. As trusted gold buyers at your doorstep, we make sure you get fair value and quick payment. Choose G1 Gold when you want to sell gold at home through a smooth and transparent process.
            </p>

            <div className="mt-9 grid gap-5 sm:grid-cols-3 sm:gap-0">
              {heroPoints.map((item, index) => (
                <div
                  key={index}
                  className={`flex flex-col items-center px-4 text-center ${
                    index !== 0 ? "sm:border-l sm:border-[#d7a51f]/45" : ""
                  }`}
                >
                  <div className="flex h-[74px] w-[74px] items-center justify-center rounded-full border border-[#e2bf58] bg-[#fffaf0] text-[#d7a51f] shadow-[0_10px_28px_rgba(216,169,31,0.12)]">
                    {renderIcon(item.icon)}
                  </div>

                  <h3 className="mt-5 max-w-[190px] text-[15px] font-extrabold leading-6 text-[#081225] sm:text-[16px]">
                    {item.title}
                  </h3>
                </div>
              ))}
            </div>
          </div>

          {/* RIGHT IMAGE */}
          <div className="mx-auto w-full max-w-[860px]">
            <div className="overflow-hidden rounded-[22px] bg-[#f7edda] shadow-[0_20px_55px_rgba(20,33,61,0.12)] lg:rounded-[24px]">
              <img
               src={serviceImages?.[0] || "/images/service/home1.webp"}
                alt={serviceTitle || "Sell gold from home doorstep gold service"}
                className="h-[300px] w-full object-cover sm:h-[420px] lg:h-[560px] xl:h-[640px]"
                onError={(e) => {
                  e.currentTarget.onerror = null;
               e.currentTarget.src = "/images/service/home1.webp";
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
const SellGoldFromHomeDetailsDesign = ({ serviceImages, serviceTitle }) => {
  const imageSrc = "/images/service/home1.webp";

  const detailsPoints = [
    {
      title: "Doorstep Gold Evaluation",
      icon: (
        <svg viewBox="0 0 24 24" className="h-8 w-8" fill="none" stroke="currentColor" strokeWidth="1.7">
          <path d="M4 11.5 12 4l8 7.5" />
          <path d="M6.5 10.5V20h11v-9.5" />
          <path d="M9.5 20v-5.5h5V20" />
          <circle cx="17" cy="17" r="1.5" />
        </svg>
      ),
    },
    {
      title: "Clear Purity & Weight Check",
      icon: (
        <svg viewBox="0 0 24 24" className="h-8 w-8" fill="none" stroke="currentColor" strokeWidth="1.7">
          <path d="M12 3v18" />
          <path d="M5 7h14" />
          <path d="M7 7l-3 6a3 3 0 0 0 6 0L7 7z" />
          <path d="M17 7l-3 6a3 3 0 0 0 6 0l-3-6z" />
          <path d="M15 18l1.5 1.5L20 16" />
        </svg>
      ),
    },
    {
      title: "Instant Payment Confirmation",
      icon: (
        <svg viewBox="0 0 24 24" className="h-8 w-8" fill="none" stroke="currentColor" strokeWidth="1.7">
          <rect x="3" y="6" width="18" height="12" rx="2" />
          <path d="M3 10h18" />
          <path d="M7 14h4" />
          <path d="M15 14l1.5 1.5L20 12" />
        </svg>
      ),
    },
  ];

  return (
    <section className="relative overflow-hidden bg-white py-8 sm:py-10 lg:py-12">
      <div className="relative mx-auto max-w-[1600px] px-4 sm:px-6 lg:px-10">
        <div className="relative overflow-hidden rounded-[22px] border border-[#d7a51f] bg-[#fffdf7] px-5 py-8 shadow-[0_22px_65px_rgba(20,33,61,0.08)] sm:px-8 lg:px-12 lg:py-12">
          <div className="grid items-center gap-8 lg:grid-cols-[0.95fr_1.05fr] lg:gap-12 xl:gap-16">
            
            {/* LEFT CONTENT */}
            <div className="w-full">
              <p className="text-[10px] font-extrabold uppercase tracking-[0.42em] text-[#b98512] sm:text-[11px]">
                Safe, Convenient, Trusted
              </p>

              <h2 className="mt-4 max-w-[560px] text-[26px] font-extrabold leading-[1.18] tracking-[0.02em] text-[#081225] sm:text-[32px] lg:text-[38px] xl:text-[42px]">
                Sell Gold from Home with a Safe and{" "}
                <span className="text-[#c89214]">Convenient Process</span>
              </h2>

              <p className="mt-5 max-w-[610px] text-[15px] font-medium leading-7 text-[#14213d] sm:text-[16px] sm:leading-8">
                Selling gold from home should feel simple, secure, and comfortable.
                G1 Gold offers a doorstep gold selling service that lets you complete
                the process from your location without visiting a branch. Our team
                visits your home, checks your gold purity and weight, and explains
                the live gold rate clearly before giving the final value.
              </p>

              <p className="mt-5 max-w-[610px] text-[15px] font-medium leading-7 text-[#14213d] sm:text-[16px] sm:leading-8">
                From old gold jewellery and broken ornaments to coins and unused
                gold items, we help customers sell with confidence through a
                transparent process. You get clear communication, fair valuation,
                and instant payment support, making the experience smooth, private,
                and hassle-free.
              </p>
<div className="mt-5 grid gap-4 sm:grid-cols-3 sm:gap-0">
  {detailsPoints.map((item, index) => (
    <div
      key={index}
      className={`flex flex-col items-center px-2 text-center ${
        index !== 0 ? "sm:border-l sm:border-[#d7a51f]/45" : ""
      }`}
    >
      <div className="flex h-[48px] w-[48px] items-center justify-center rounded-full border border-[#e2bf58] bg-[#fffaf0] text-[20px] text-[#d7a51f]">
        {item.icon}
      </div>

      <h3 className="mt-3 max-w-[145px] text-[10px] font-bold leading-4 text-[#081225] sm:text-[11px]">
        {item.title}
      </h3>
    </div>
  ))}
</div>
            </div>

       {/* RIGHT IMAGE */}
{/* Right Image */}
{/* Right Image */}
<div className="relative overflow-hidden rounded-[18px] bg-white shadow-[0_18px_55px_rgba(20,33,61,0.12)]">
  <img
    src={`${process.env.PUBLIC_URL}/images/service/home1.webp`}
    alt="Sell gold for cash with clear testing and instant payment"
    className="h-[300px] w-full object-cover object-center sm:h-[420px] lg:h-[470px]"
    onError={(e) => {
      e.currentTarget.onerror = null;
      e.currentTarget.src = `${process.env.PUBLIC_URL}/images/service/cashforgold.webp`;
    }}
  />

  <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-[#081225]/12 via-transparent to-transparent" />
</div>
</div>

          </div>
        </div>
    </section>
  );
};
const SellGoldFromHomeWhyDesign = ({ serviceImages = [] }) => {
  const getImagePath = (path) => {
    if (!path) return "";
    if (path.startsWith("http")) return path;
    return `${process.env.PUBLIC_URL}${path.startsWith("/") ? path : `/${path}`}`;
  };

  const imageSrc =
    getImagePath(serviceImages?.[0]) ||
    getImagePath(serviceImages?.[1]) ||
    getImagePath(serviceImages?.[2]) ||
    `${process.env.PUBLIC_URL}/images/service/sell-gold-from-home-0.webp`;

  const cards = [
    {
      title: "Safe Doorstep Gold Service",
      description:
        "Sell gold from home safely through our doorstep service, handled by trained G1 Gold staff.",
    },
    {
      title: "Transparent Home Gold Testing",
      description:
        "Your gold is tested at home for purity and weight, so you clearly understand its value.",
    },
    {
      title: "Live Gold Rate Valuation",
      description:
        "Your gold value is calculated using the live gold rate, purity, and weight for fair pricing.",
    },
    {
      title: "Instant Payment After Approval",
      description:
        "After you approve the offer, receive instant payment through cash or secure bank transfer.",
    },
    {
      title: "No Hidden Charges",
      description:
        "Enjoy a clear doorstep gold selling process with no hidden fees, deductions, or pressure to sell.",
    },
  ];

  return (
  <section className="relative overflow-hidden bg-[#071225] py-10 sm:py-12 lg:py-14">
  {/* Premium background */}
  <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_12%_12%,rgba(215,165,31,0.12),transparent_30%),radial-gradient(circle_at_82%_45%,rgba(244,209,107,0.08),transparent_38%)]" />
  <div className="pointer-events-none absolute -left-44 top-0 h-[420px] w-[420px] rounded-full bg-[#d7a51f]/10 blur-[130px]" />
  <div className="pointer-events-none absolute -right-44 bottom-0 h-[520px] w-[520px] rounded-full bg-[#f4d16b]/8 blur-[150px]" />

  <div className="relative mx-auto max-w-[1450px] px-4 sm:px-6 lg:px-12">
    {/* CENTER CONTENT */}
    <div className="relative z-20 mx-auto text-center">
      <p className="relative inline-block text-[10px] font-extrabold uppercase tracking-[0.28em] text-[#f4d16b] sm:text-[11px]">
        Service Details
        <span className="absolute -bottom-3 left-1/2 h-[2px] w-full -translate-x-1/2 rounded-full bg-[#d7a51f]" />
      </p>

      <h2 className="mx-auto mt-8 max-w-[760px] text-[28px] font-extrabold leading-[1.18] tracking-[0.02em] text-white sm:text-[34px] lg:text-[40px] xl:text-[44px]">
        Why Sell Gold from Home with{" "}
        <span className="text-[#d7a51f]">G1 Gold?</span>
      </h2>

      <div className="mx-auto mt-8 flex max-w-[1180px] flex-wrap justify-center gap-4">
        {cards.map((item, index) => (
          <article
            key={index}
            className="group relative min-h-[168px] w-full overflow-hidden rounded-[18px] border border-white/10 bg-white/[0.055] p-5 text-left shadow-[0_18px_45px_rgba(0,0,0,0.18)] backdrop-blur-sm transition-all duration-300 hover:-translate-y-1 hover:border-[#d7a51f]/55 hover:bg-white/[0.075] sm:w-[calc(50%-8px)] lg:w-[calc(33.333%-11px)]"
          >
            {/* top glow line */}
            <div className="absolute left-0 top-0 h-[3px] w-full bg-gradient-to-r from-[#d7a51f] via-[#f4d16b] to-transparent opacity-80" />

            <h3 className="mt-1 text-[15px] font-extrabold leading-snug text-white sm:text-[16px]">
              {item.title}
            </h3>

            <div className="mt-4 h-[2px] w-9 rounded-full bg-[#d7a51f]" />

            <p className="mt-4 text-[13px] font-medium leading-6 text-[#e8eefb]">
              {item.description}
            </p>
          </article>
        ))}
      </div>
    </div>
  </div>
</section>
  );
};
const SellGoldFromHomeTypesDesign = ({ section, serviceImages = [] }) => {
  const getImagePath = (path) => {
    if (!path) return "";
    if (path.startsWith("http")) return path;
    return `${process.env.PUBLIC_URL}${path.startsWith("/") ? path : `/${path}`}`;
  };

  const imageSrc =
    getImagePath(serviceImages?.[1]) ||
    getImagePath(serviceImages?.[0]) ||
    getImagePath(serviceImages?.[2]) ||
    `${process.env.PUBLIC_URL}/images/service/sell-gold-from-home-2.webp`;

  const fallbackItems = [
    {
      title: "Old Gold Jewellery",
      description:
        "Sell old or outdated gold jewellery from home and receive a clear value after testing.",
    },
    {
      title: "Broken or Unused Gold Items",
      description:
        "Turn broken or unused gold items into cash with simple home testing and clear pricing.",
    },
    {
      title: "Gold Coins and Bars",
      description:
        "Get fair value for gold coins and bars through accurate testing and live rate pricing.",
    },
    {
      title: "Scrap or Damaged Gold",
      description:
        "Sell scrap or damaged gold easily from home after purity check, weight check, and valuation.",
    },
  ];

  const displayItems =
    section?.items?.length > 0 ? section.items.slice(0, 4) : fallbackItems;

  const bottomHighlights = [
    "Accepted Gold Jewellery",
    "Clear Home Testing",
    "Live Rate Valuation",
    "Instant Payment Support",
  ];

  return (
<section className="relative overflow-hidden bg-[#fffdf7] py-8 sm:py-14 lg:py-16">
  {/* premium soft background */}
  <div className="pointer-events-none absolute -left-40 top-0 h-[420px] w-[420px] rounded-full bg-[#f4d16b]/20 blur-[130px]" />
  <div className="pointer-events-none absolute -right-44 bottom-0 h-[520px] w-[520px] rounded-full bg-[#c89214]/10 blur-[150px]" />
  <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-[#d7a51f]/50 to-transparent" />

  <div className="relative mx-auto max-w-[1600px] px-4 sm:px-6 lg:px-12">
    <div className="rounded-[22px] border border-[#ead8a8] bg-white px-4 py-7 shadow-[0_28px_80px_rgba(20,33,61,0.08)] sm:rounded-[30px] sm:px-7 sm:py-10 lg:px-10">
      <div className="grid items-center gap-8 sm:gap-10 lg:grid-cols-[0.78fr_1.22fr] xl:gap-14">
        
        {/* LEFT CONTENT */}
        <div className="relative z-20">
          <p className="relative inline-block text-[9px] font-extrabold uppercase tracking-[0.22em] text-[#b98512] sm:text-[11px] sm:tracking-[0.28em]">
            Service Details
            <span className="absolute -bottom-3 left-0 h-[2px] w-full rounded-full bg-[#d7a51f]" />
          </p>

          <h2 className="mt-8 max-w-[570px] text-[clamp(25px,7vw,32px)] font-extrabold leading-[1.14] tracking-[0.01em] text-[#081225] sm:text-[36px] sm:tracking-[0.02em] lg:text-[42px] xl:text-[48px]">
            What Types of Gold Can You Sell{" "}
            <span className="text-[#c89214]">from Home?</span>
          </h2>

          {section?.description && (
            <p className="mt-4 max-w-[560px] text-[13px] font-medium leading-6 text-[#2f3b52] sm:mt-5 sm:text-[14px]">
              {section.description}
            </p>
          )}

          <div className="mt-6 space-y-4 sm:mt-8 sm:space-y-5">
            {displayItems.map((item, index) => (
              <div key={index} className="relative flex gap-3.5 sm:gap-5">
                {index !== displayItems.length - 1 && (
                  <span className="absolute left-[21px] top-[48px] h-[calc(100%+6px)] w-px bg-[#d7a51f]/35 sm:left-[25px] sm:top-[54px] sm:h-[calc(100%+8px)]" />
                )}

                <div className="relative z-10 flex h-[44px] w-[44px] shrink-0 items-center justify-center rounded-full border border-[#d7a51f]/50 bg-[#fff7df] text-[#c89214] shadow-[0_12px_28px_rgba(216,169,31,0.18)] sm:h-[52px] sm:w-[52px]">
                  <span className="text-[12px] font-extrabold leading-none sm:text-[14px]">
                    {String(index + 1).padStart(2, "0")}
                  </span>
                </div>

                <div className="min-w-0 pt-0.5 sm:pt-1">
                  <h3 className="text-[15px] font-extrabold leading-snug text-[#081225] sm:text-[17px]">
                    {item.title}
                  </h3>

                  <p className="mt-1.5 max-w-[500px] text-[12.5px] font-medium leading-5 text-[#334155] sm:mt-2 sm:text-[14px] sm:leading-6">
                    {item.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* RIGHT VISUAL */}
        <div className="relative z-10">
          <div className="overflow-hidden rounded-[20px] border border-[#ead8a8] bg-[#fffaf0] shadow-[0_24px_65px_rgba(20,33,61,0.10)] sm:rounded-[26px]">
            <div className="relative">
              <img
                src={`${process.env.PUBLIC_URL}/images/service/sell-gold-from-home.webp`}
                alt="Types of gold accepted for sell gold from home service"
                className="h-[clamp(240px,70vw,320px)] w-full object-cover object-center sm:h-[380px] lg:h-[470px] xl:h-[520px]"
                style={{
                  objectPosition: "center center",
                }}
                onError={(e) => {
                  e.currentTarget.onerror = null;
                  e.currentTarget.src = `${process.env.PUBLIC_URL}/images/service/sell-gold-from-home.webp`;
                }}
              />

              <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-[#081225]/18 via-transparent to-transparent" />

              <div className="absolute right-3 top-3 hidden rounded-b-[18px] rounded-t-[4px] bg-[#f4d16b] px-3.5 py-3.5 text-center shadow-[0_12px_35px_rgba(0,0,0,0.18)] sm:block sm:right-5 sm:top-5 sm:rounded-b-[22px] sm:px-5 sm:py-5">
                <div className="mx-auto flex h-7 w-7 items-center justify-center rounded-full border border-[#071225]/25 text-[12px] text-[#071225] sm:h-9 sm:w-9 sm:text-base">
                  ✓
                </div>
                <p className="mt-1.5 text-[9px] font-extrabold uppercase leading-3 tracking-[0.07em] text-[#071225] sm:mt-2 sm:text-[11px] sm:leading-4 sm:tracking-[0.08em]">
                  Gold
                  <br />
                  Accepted
                </p>
                <p className="mt-1 text-[10px] tracking-[0.14em] text-[#071225] sm:text-[12px] sm:tracking-[0.18em]">
                  ★★★
                </p>
              </div>
            </div>
          </div>

          <div className="mt-5 grid overflow-hidden rounded-[18px] border border-[#ead8a8] bg-white shadow-[0_18px_45px_rgba(20,33,61,0.07)] sm:mt-6 sm:grid-cols-2 sm:rounded-[22px] lg:grid-cols-4">
            {bottomHighlights.map((item, index) => (
              <div
                key={index}
                className={`group relative px-4 py-4 text-center transition-all duration-300 hover:-translate-y-1 hover:bg-[#fffaf0] sm:px-5 sm:py-5 ${
                  index !== 0
                    ? "border-t border-[#ead8a8] sm:border-l sm:border-t-0"
                    : ""
                }`}
              >
                <div className="relative mx-auto mb-2.5 flex h-9 w-9 items-center justify-center rounded-full border border-[#d7a51f]/45 bg-[#fff7df] text-[16px] font-extrabold text-[#c89214] transition-all duration-300 group-hover:scale-110 group-hover:border-[#d7a51f] group-hover:shadow-[0_0_22px_rgba(215,165,31,0.35)] sm:mb-3 sm:h-10 sm:w-10 sm:text-[18px]">
                  <span className="absolute inset-0 rounded-full bg-[#d7a51f]/20 opacity-0 transition-all duration-500 group-hover:scale-125 group-hover:opacity-100" />
                  <span className="relative transition-transform duration-300 group-hover:rotate-12">
                    ✓
                  </span>
                </div>

                <p className="text-[12.5px] font-extrabold leading-5 text-[#081225] transition-colors duration-300 group-hover:text-[#9b6a00] sm:text-[13px]">
                  {item}
                </p>

                <div className="mx-auto mt-2.5 h-[2px] w-7 rounded-full bg-[#d7a51f] transition-all duration-300 group-hover:w-12 sm:mt-3 sm:w-8" />
              </div>
            ))}
          </div>
        </div>

      </div>
    </div>
  </div>
</section>
  );
};
const ReleasePledgedGoldChooseDesign = () => {
  const cards = [
    {
      title: "Trusted and Transparent",
      description:
        "We follow a clear and open process with no hidden charges at any stage.",
      icon: serviceIcons.shield,
    },
    {
      title: "Fair Valuation",
      description:
        "Live gold rate based valuation with accurate purity and weight check.",
      icon: serviceIcons.valuation,
    },
    {
      title: "Quick Settlement",
      description:
        "Get smooth support for faster pledged gold release and final value confirmation.",
      icon: serviceIcons.payment,
    },
    {
      title: "Proper Documentation",
      description:
        "Complete documentation and receipts for a safe and secure transaction.",
      icon: serviceIcons.document,
    },
  ];

  return (
    <section className="relative overflow-hidden bg-white py-10 sm:py-12 lg:py-14">
      <div className="pointer-events-none absolute -left-32 top-0 h-[260px] w-[260px] rounded-full bg-[#f4d16b]/10 blur-[95px]" />
      <div className="pointer-events-none absolute -right-32 bottom-0 h-[300px] w-[300px] rounded-full bg-[#c89214]/8 blur-[110px]" />

      <div className="relative mx-auto max-w-[1180px] px-4 sm:px-6 lg:px-8">
        <div className="mb-6 text-center">
          <h2 className="text-[22px] font-extrabold leading-tight tracking-[-0.02em] text-[#111827] sm:text-[26px] lg:text-[30px]">
            Why Choose Our{" "}
            <span className="text-[#c89214]">
              Pledged Gold Release Service?
            </span>
          </h2>

          <div className="mx-auto mt-3 h-[2px] w-16 rounded-full bg-[#d7a51f]" />
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {cards.map((card, index) => (
            <article
              key={index}
              className="group relative min-h-[160px] rounded-[10px] border border-[#ead8a8]/65 bg-white px-5 py-5 text-center shadow-[0_10px_30px_rgba(20,33,61,0.05)] transition-all duration-300 hover:-translate-y-1 hover:border-[#d7a51f] hover:shadow-[0_16px_38px_rgba(198,146,24,0.12)]"
            >
              <div className="mx-auto flex h-[54px] w-[54px] items-center justify-center rounded-full border border-[#f0d99a] bg-[#fffaf0] text-[#d7a51f] transition-all duration-300 group-hover:scale-105 group-hover:bg-[#fff4d7]">
                <span className="[&_svg]:h-7 [&_svg]:w-7">
                  {card.icon}
                </span>
              </div>

              <h3 className="mt-4 text-[15px] font-extrabold leading-snug text-[#111827]">
                {card.title}
              </h3>

              <div className="mx-auto mt-3 h-[2px] w-9 rounded-full bg-[#d7a51f]" />

              <p className="mx-auto mt-3 max-w-[220px] text-[12.5px] font-medium leading-5 text-[#4b5563]">
                {card.description}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
const ReleasePledgedGoldLoanOptionsDesign = () => {
  const possibleOptions = [
    "Pay the outstanding amount yourself and close the gold loan directly with the lender.",
    "Ask the lender about renewal or repayment options if your loan is still eligible.",
    "Arrange funds from another source to clear the outstanding balance and collect your jewellery.",
    "Use pledged gold release assistance if arranging the entire settlement amount yourself is difficult.",
  ];

  

  return (
    <section className="relative overflow-hidden bg-[#fffdf8] py-10 sm:py-12 lg:py-14">
      {/* SOFT BACKGROUND */}
      <div className="pointer-events-none absolute -left-32 top-10 h-[300px] w-[300px] rounded-full bg-[#f4d16b]/10 blur-[100px]" />
      <div className="pointer-events-none absolute -right-32 bottom-0 h-[340px] w-[340px] rounded-full bg-[#c89214]/8 blur-[110px]" />

      <div className="relative mx-auto max-w-[1450px] px-4 sm:px-6 lg:px-10">

        {/* ================= TOP AREA ================= */}
        <div className="grid items-stretch gap-7 lg:grid-cols-[0.43fr_0.57fr] lg:gap-10">

          {/* LEFT IMAGE */}
          <div className="relative overflow-hidden rounded-[16px] border border-[#ead8a8] bg-[#f6efe1] shadow-[0_18px_45px_rgba(20,33,61,0.09)]">

            <img
              src={`${process.env.PUBLIC_URL}/images/service/pledged-loan-options.webp`}
              alt="Gold jewellery held while reviewing gold loan repayment options"
              className="h-[330px] w-full object-cover object-center sm:h-[420px] lg:h-full lg:min-h-[500px]"
              loading="lazy"
              onError={(e) => {
                e.currentTarget.onerror = null;
                e.currentTarget.src =
                  `${process.env.PUBLIC_URL}/images/service/release4.jpg`;
              }}
            />

           
          </div>

          {/* RIGHT CONTENT */}
          <div className="flex flex-col justify-center">

            <h2 className="max-w-[690px] text-[25px] font-extrabold leading-[1.15] tracking-[-0.02em] text-[#07152B] sm:text-[31px] lg:text-[36px]">
              What If You Don&apos;t Have Enough Money
             to Close Your Gold Loan?
            </h2>

            <div className="mt-4 h-[3px] w-12 rounded-full bg-[#d8a018]" />

            <p className="mt-5 max-w-[760px] text-[13px] font-medium leading-6 text-[#344054] sm:text-[14px]">
              If you do not have enough money to repay your gold loan in full,
              you do not necessarily have to leave your pledged jewellery with
              the lender. Depending on the loan status, outstanding amount and
              lender&apos;s terms, you may be able to explore different ways to
              settle the loan and recover your gold.
            </p>

            <h3 className="mt-5 text-[13px] font-extrabold text-[#17202a] sm:text-[14px]">
              Possible options may include:
            </h3>

            {/* OPTIONS */}
            <div className="mt-4 space-y-3">
              {possibleOptions.map((item, index) => (
                <div
                  key={index}
                  className="flex items-start gap-3"
                >
                  <span className="mt-[2px] flex h-[20px] w-[20px] shrink-0 items-center justify-center rounded-full bg-[#07152B] text-[11px] font-bold text-white">
                    ✓
                  </span>

                  <p className="text-[12.5px] font-medium leading-5 text-[#263238] sm:text-[13.5px]">
                    {item}
                  </p>
                </div>
              ))}
            </div>

            {/* INFO BOX */}
            <div className="mt-6 flex items-start gap-3 rounded-[12px] border border-[#e4c15c] bg-[#fff7dc] px-4 py-4 sm:px-5">

              <div className="flex h-[30px] w-[30px] shrink-0 items-center justify-center rounded-full bg-[#d39a16] text-[15px] font-extrabold text-white">
                i
              </div>

              <p className="text-[12px] font-medium leading-5 text-[#4a4230] sm:text-[13px]">
                G1 Gold can help you understand the pledged gold release
                process in Bangalore, including the outstanding amount and
                steps involved in settling the loan and recovering your
                jewellery. The available option will depend on your lender,
                loan status and settlement requirements.
              </p>
            </div>
          </div>
        </div>

      
      </div>
    </section>
  );
};
const ReleasePledgedGoldWhyDesign = ({ section, serviceImages = [], serviceTitle = "",  processImageAlt = "",}) => {
  const getImagePath = (path) => {
    if (!path) return "";
    if (path.startsWith("http")) return path;
    return `${process.env.PUBLIC_URL}${path.startsWith("/") ? path : `/${path}`}`;
  };

  const imageSrc =
    getImagePath(serviceImages?.[0]) ||
    getImagePath(serviceImages?.[1]) ||
    getImagePath(serviceImages?.[2]) ||
    `${process.env.PUBLIC_URL}/images/service/release-pledged-gold-0.webp`;

  const fallbackItems = [
    {
      title: "Trusted and Transparent Support",
      description:
        "Our team guides you through the pledged gold release process with clear communication and proper support.",
      icon: serviceIcons.shield,
    },
    {
      title: "Fair Valuation and Guidance",
      description:
        "Your gold details are reviewed carefully so you understand the process before moving ahead.",
      icon: serviceIcons.valuation,
    },
    {
      title: "Quick Settlement Assistance",
      description:
        "We help you with smooth coordination and fast support to release your pledged gold safely.",
      icon: serviceIcons.payment,
    },
  ];

  const displayItems =
    section?.items?.length > 0
      ? section.items.slice(0, 3).map((item) => ({
          ...item,
          icon: getServiceItemIcon(item.title, item.description),
        }))
      : fallbackItems;

  return (
    <section className="relative overflow-hidden bg-[#fffdf7] py-12 sm:py-14 lg:py-16">
      {/* Premium background */}
      <div className="pointer-events-none absolute -left-40 top-0 h-[420px] w-[420px] rounded-full bg-[#f4d16b]/20 blur-[130px]" />
      <div className="pointer-events-none absolute -right-44 bottom-0 h-[520px] w-[520px] rounded-full bg-[#c89214]/10 blur-[150px]" />

      <div className="relative mx-auto max-w-[1600px] px-4 sm:px-6 lg:px-12">
        <div className="grid items-center gap-10 rounded-[30px] border border-[#ead8a8] bg-white px-5 py-8 shadow-[0_28px_80px_rgba(20,33,61,0.08)] sm:px-7 sm:py-10 lg:grid-cols-[0.95fr_1.05fr] lg:px-10 xl:gap-14">
          
          {/* LEFT CONTENT */}
          <div>
   <p className="text-[10px] font-extrabold uppercase tracking-[0.30em] text-[#b98512] sm:text-[11px]">
              Our Process
            </p>

           <h2 className="mt-5 max-w-[620px] text-[22px] font-extrabold leading-[1.22] tracking-[0.01em] text-[#081225] sm:text-[28px] lg:text-[34px] xl:text-[38px]">
              Release Pledged Gold Through a Simple and{" "}
              <span className="text-[#c89214]">Transparent Process</span>
            </h2>

       <p className="mt-4 max-w-[620px] text-[13px] font-medium leading-6 text-[#2f3b52] sm:text-[14px]">
  G1 Gold helps you release pledged gold through a safe, clear, and stress-free process.
  If your gold is pledged with a bank or finance company, our team guides you step by step
  and explains the closure process before you decide. After the pledge is cleared, we check
  the purity and weight carefully and share the value clearly. If you want to sell pledged gold,{" "}
  <a href="https://g1gold.com/">
    <strong>G1 Gold</strong>
  </a>{" "}
  offers fair valuation, quick payment, and trusted support for customers searching for
  pledged gold buyers near me.
</p>

          

           <div className="mt-7 grid gap-5 sm:grid-cols-3 sm:gap-0">
  {displayItems.map((item, index) => (
    <div
      key={index}
      className={`group flex flex-col items-center px-4 text-center transition-all duration-300 hover:-translate-y-1 ${
        index !== 0 ? "sm:border-l sm:border-[#d7a51f]/35" : ""
      }`}
    >
      <div className="relative flex h-[54px] w-[54px] items-center justify-center rounded-full border border-[#e2bf58] bg-[#fffaf0] text-[#c89214] shadow-[0_10px_26px_rgba(216,169,31,0.12)] transition-all duration-300 group-hover:scale-110 group-hover:border-[#d7a51f] group-hover:shadow-[0_0_24px_rgba(215,165,31,0.32)]">
        <span className="absolute inset-0 rounded-full bg-[#d7a51f]/20 opacity-0 transition-all duration-500 group-hover:scale-125 group-hover:opacity-100" />

        <span className="relative text-[22px] font-extrabold leading-none transition-transform duration-300 group-hover:rotate-12">
          ✓
        </span>
      </div>

      <h3 className="mt-4 text-[12px] font-extrabold leading-5 text-[#081225] transition-colors duration-300 group-hover:text-[#9b6a00] sm:text-[13px]">
        {item.title}
      </h3>

      <p className="mt-2 text-[11.5px] font-medium leading-5 text-[#475569]">
        {item.description}
      </p>
    </div>
  ))}
</div>
          </div>

        {/* RIGHT IMAGE */}
<div className="mx-auto w-full max-w-[780px] lg:max-w-none">
  <div className="overflow-hidden rounded-[24px] bg-transparent shadow-[0_24px_65px_rgba(20,33,61,0.12)]">
    <img
      src={`${process.env.PUBLIC_URL}/images/service/pledged1.webp`}
     alt={
  processImageAlt ||
  serviceTitle ||
  "Customer receiving pledged gold after loan closure"
}
      className="h-[280px] w-full object-cover object-center sm:h-[390px] lg:h-[500px] xl:h-[560px]"
      onError={(e) => {
        e.currentTarget.onerror = null;
        e.currentTarget.src = `${process.env.PUBLIC_URL}/images/service/release-pledged-gold-2.webp`;
      }}
    />
  </div>
</div>

        </div>
      </div>
    </section>
  );
};
const ReleasePledgedGoldBangaloreSpecialDesign = () => {
  const reviewItems = [
    "Your gold loan details",
    "Outstanding amount",
    "Lender settlement requirements",
    "Steps to recover your pledged jewellery",
  ];

  return (
    <section className="relative overflow-hidden bg-[#f8f5ed] py-8 sm:py-10 lg:py-12">

      {/* SOFT BACKGROUND */}
      <div className="pointer-events-none absolute -left-32 top-0 h-[320px] w-[320px] rounded-full bg-[#e8b834]/10 blur-[110px]" />
      <div className="pointer-events-none absolute right-0 bottom-0 h-[360px] w-[360px] rounded-full bg-[#d7a51f]/8 blur-[120px]" />

      <div className="relative mx-auto max-w-[1500px] px-4 sm:px-6 lg:px-8">

        {/* MAIN CARD */}
        <div className="overflow-hidden rounded-[16px] border border-[#eadbb8] bg-[#fffdf8] px-5 py-6 shadow-[0_20px_55px_rgba(20,33,61,0.08)] sm:px-7 sm:py-7 lg:px-9 lg:py-8">

          {/* ================= TOP SECTION ================= */}
          <div className="grid items-start gap-6 lg:grid-cols-[1.2fr_0.8fr] lg:gap-8">
            {/* LEFT SIDE */}
            <div>
              <h2 className="text-[27px] font-extrabold leading-[1.12] tracking-[-0.02em] text-[#07152B] sm:text-[34px] lg:text-[38px] xl:text-[42px]">
                Release Pledged Gold in Bangalore
              </h2>

              <p className="mt-1 text-[21px] font-extrabold leading-tight text-[#d29a18] sm:text-[25px] lg:text-[28px]">
                When Full Repayment Is Difficult
              </p>

              {/* LOAN INFORMATION BOX */}
              <div className="mt-6 flex items-start gap-4 rounded-[14px] border border-[#eadfca] bg-white px-4 py-4 shadow-[0_8px_22px_rgba(20,33,61,0.06)] sm:px-5 sm:py-5">

                {/* BANK ICON */}
                <div className="flex h-[58px] w-[58px] shrink-0 items-center justify-center rounded-full bg-[#07152B] text-white">
                  <svg
                    viewBox="0 0 24 24"
                    className="h-8 w-8"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M3 10h18" />
                    <path d="M5 10v8" />
                    <path d="M9 10v8" />
                    <path d="M15 10v8" />
                    <path d="M19 10v8" />
                    <path d="M3 18h18" />
                    <path d="M12 3l9 5H3l9-5z" />
                  </svg>
                </div>

                <p className="text-[13px] font-medium leading-[1.6] text-[#263238] sm:text-[14px]">
                  If your gold jewellery is currently pledged with a bank,
                  NBFC, or gold loan company, getting it back requires
                  settlement of the outstanding gold loan. The lender continues
                  to hold your jewellery until the required amount is cleared
                  and the account is closed.
                </p>
              </div>
            </div>

           {/* CENTER IMAGE */}
<div className="flex h-[200px] items-center justify-center sm:h-[220px] lg:h-[240px]">
  <img
    src={`${process.env.PUBLIC_URL}/images/service/release3.jpg`}
    alt="Release Pledged Jewellery in Bangalore with gold ornaments."
    className="max-h-[240px] w-full max-w-[450px] object-contain object-cente"
    loading="lazy"
    onError={(e) => {
      e.currentTarget.onerror = null;
      e.currentTarget.src =
        `${process.env.PUBLIC_URL}/images/service/release-pledged-gold-0.webp`;
    }}
  />
</div>

         
          </div>

         

          {/* ================= BOTTOM SECTION ================= */}
          <div className="mt-3 grid items-stretch gap-4 lg:grid-cols-[1.55fr_0.75fr]">

            {/* LEFT GREEN BOX */}
            <div className="flex flex-col gap-5 rounded-[13px] bg-[#07152B] px-5 py-5 text-white shadow-[0_12px_30px_rgba(7,81,63,0.20)] sm:flex-row sm:px-6 sm:py-6">

              {/* RELEASE ICON */}
              <div className="flex h-[72px] w-[72px] shrink-0 items-center justify-center rounded-full border-2 border-[#dca315] text-[#efb51c]">
                <svg
                  viewBox="0 0 24 24"
                  className="h-9 w-9"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="5" y="10" width="14" height="10" rx="2.5" />
                  <path d="M8 10V7.5a4 4 0 0 1 7.5-2" />
                  <path d="M14 5h4v4" />
                  <path d="M18 5l-5 5" />
                </svg>
              </div>

              {/* TEXT */}
              <div className="min-w-0 flex-1">
                <p className="text-[14px] font-medium leading-6 text-white sm:text-[15px]">
                  When arranging the full repayment amount is difficult,{" "}
                  <strong className="font-extrabold text-[#f2b51d]">
                   G1 Gold can assist with the pledged gold release in Bangalore process. Bring your gold loan details for review so you can understand the outstanding amount, lender settlement requirements, and the steps needed to recover your pledged jewellery.
                  </strong>
                </p>

                <p className="mt-2 text-[13px] font-medium leading-6 text-white/95 sm:text-[14px]">
                  Instead of allowing interest or pending dues to continue increasing, you can review the available release option and decide whether to proceed. The process moves forward only after you understand the settlement and approve it. 
                </p>
              </div>
            </div>

            {/* RIGHT WE REVIEW BOX */}
            <div className="rounded-[13px] border border-[#d9b14e] bg-white px-5 py-5 shadow-[0_10px_25px_rgba(20,33,61,0.06)] sm:px-6">

              <h3 className="text-[15px] font-extrabold uppercase tracking-[0.04em] text-[#17202a]">
                We Review
              </h3>

              <div className="mt-3 space-y-2">
                {reviewItems.map((item, index) => (
                  <div
                    key={index}
                    className="flex items-start gap-2"
                  >
                    <span className="mt-[1px] flex h-[18px] w-[18px] shrink-0 items-center justify-center rounded-full bg-[#07152B] text-[11px] font-bold text-white">
                      ✓
                    </span>

                    <p className="text-[13px] font-medium leading-5 text-[#263238] sm:text-[14px]">
                      {item}
                    </p>
                  </div>
                ))}
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};
const createMobileHeroDescription = (
  html = "",
  targetWords = 24,
  hardMaxWords = 32
) => {
  const text = String(html)
    .replace(/<[^>]*>/g, " ")
    .replace(/&nbsp;/g, " ")
    .replace(/&amp;/g, "&")
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/&rsquo;/g, "'")
    .replace(/\s+/g, " ")
    .trim();

  if (!text) return "";

  const words = text.split(" ");

  // Content already short
  if (words.length <= targetWords) {
    return text;
  }

  /*
   * 1. Check only a few words BEFORE 24.
   * We only accept a sentence ending here.
   *
   * This fixes:
   * "...financial situation. Check..."
   */
  const lookBackStart = Math.max(0, targetWords - 4);

  for (let i = targetWords - 1; i >= lookBackStart; i--) {
    if (/[.!?]["')\]]?$/.test(words[i])) {
      return words.slice(0, i + 1).join(" ");
    }
  }

  /*
   * 2. Starting around word 24,
   * search FORWARD for natural punctuation.
   *
   * Comma is allowed here,
   * but NOT an old comma earlier in the paragraph.
   */
  const forwardLimit = Math.min(words.length, hardMaxWords);

  for (let i = targetWords - 1; i < forwardLimit; i++) {
    if (/[,.;:!?]["')\]]?$/.test(words[i])) {
      return words.slice(0, i + 1).join(" ");
    }
  }

  /*
   * 3. If complete paragraph is only slightly longer,
   * show the whole thing.
   */
  if (words.length <= hardMaxWords) {
    return text;
  }

  /*
   * 4. Final fallback.
   * Never show "..."
   */
  return words.slice(0, hardMaxWords).join(" ");
};

const ReleasePledgedGoldLocationPage = ({ page }) => {
  const slug = "release-pledged-gold";


  

  const reviewVisibleSlugs = [
    "sell-gold-in-malleshwaram",
    "sell-gold-in-bangalore",
  ];

  const showCustomerReviews = reviewVisibleSlugs.includes(slug?.toLowerCase());

const currentSchema = [];
  const [service, setService] = useState(page || null);
  const [notFound, setNotFound] = useState(!page);
  const [showAllFaqs, setShowAllFaqs] = useState(false);
  const [openFaqIndex, setOpenFaqIndex] = useState(null);
  const [activeWhyIndex, setActiveWhyIndex] = useState(0);
  
  
const isReleasePledgedGoldBangalorePage =

    page?.slug === "release-pledged-gold-in-bangalore" ||
  page?.slug === "pledged-gold-buyers-in-bangalore";



  const mobileHeroDescriptions = {
  "pledged-gold-buyers-in-bangalore":
    "Sell pledged gold in Bangalore with clear loan settlement guidance, transparent valuation, and quick payment after approval.",

  "release-pledged-gold-in-bangalore":
    "Release pledged gold in Bangalore with flexible repayment support, clear guidance, and a transparent process.",
};
const mobileHeroDescription =
  mobileHeroDescriptions[page?.slug] ||
  createMobileHeroDescription(page?.bannerDescription);
useEffect(() => {
  setService(page || null);
  setNotFound(!page);
  setShowAllFaqs(false);
  setOpenFaqIndex(null);
  setActiveWhyIndex(0);
}, [page]);

  const serviceImages = useMemo(() => {
    return serviceImageMap[slug] || fallbackImages;
  }, [slug]);

  const siteUrl = "https://g1gold.com";
const canonicalUrl =
  service?.canonical ||
  `${siteUrl}/${service?.slug || "release-pledged-gold-malleshwaram"}`;

const meta = ogMetaMap[slug] || {};

const toAbsoluteUrl = (path = "") => {
  if (!path) return `${siteUrl}/images/service/home1.webp`;
  if (path.startsWith("http")) return path;
  return `${siteUrl}${path.startsWith("/") ? path : `/${path}`}`;
};

const pageTitle =
  service?.metaTitle ||
  meta.title ||
  service?.title ||
  "G1 Gold | Trusted Gold Buyers in Bangalore";

const pageDescription =
  service?.metaDescription ||
  meta.description ||
  service?.bannerDescription ||
  "G1 Gold offers trusted gold buying services with transparent valuation and instant payment.";

  useEffect(() => {
  if (!service || !pageDescription) return;

  let descriptionTag =
    document.head.querySelector('meta[name="description"]');

  if (!descriptionTag) {
    descriptionTag = document.createElement("meta");
    descriptionTag.setAttribute("name", "description");
    document.head.appendChild(descriptionTag);
  }

  descriptionTag.setAttribute(
    "content",
    pageDescription
  );
}, [service, pageDescription]);


const pageImage = toAbsoluteUrl(
  service?.ogImage ||
  meta.image ||
  serviceImages?.[0]
);
const pageImageAlt =
  service?.ogImageAlt ||
  meta.imageAlt ||
  serviceImageAltMap[slug]?.[0] ||
  service?.title ||
  "G1 Gold service image";
  const robotsContent =
  slug === "convert-old-gold-to-new-gold"
    ? "noindex, nofollow"
    : "index, follow";

  const visibleFaqs = useMemo(() => {
    if (!service?.faqs) return [];
    return showAllFaqs ? service.faqs : service.faqs.slice(0, 5);
  }, [service, showAllFaqs]);

if (notFound) return <Navigate to="/services" replace />;

  if (!service) {
    return (
      <div className="min-h-screen bg-white">

  <Helmet>
  <title>{pageTitle}</title>
  <meta name="description" content={pageDescription} />
  <meta name="robots" content={robotsContent} />
<meta name="googlebot" content={robotsContent} />
  <link rel="canonical" href={canonicalUrl} />

  <meta property="og:type" content="website" />
  <meta property="og:title" content={pageTitle} />
  <meta property="og:description" content={pageDescription} />
  <meta property="og:url" content={canonicalUrl} />
  <meta property="og:image" content={pageImage} />
  <meta property="og:image:alt" content={pageImageAlt} />

  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content={pageTitle} />
  <meta name="twitter:description" content={pageDescription} />
  <meta name="twitter:image" content={pageImage} />

  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Service",
      name: service?.title,
      description: pageDescription,
      url: canonicalUrl,
      image: pageImage,
      provider: {
        "@type": "LocalBusiness",
        name: "G1 Gold",
        url: siteUrl,
        telephone: "+91 7996 800 900",
        address: {
          "@type": "PostalAddress",
          streetAddress:
            "1st Floor, Satya Sai Complex, No. 224, 14th Cross, Sampige Road, Malleswaram",
          addressLocality: "Bengaluru",
          addressRegion: "Karnataka",
          postalCode: "560003",
          addressCountry: "IN"
        }
      }
    })}
  </script>
</Helmet>


        <Header />
        <div className="flex min-h-[60vh] items-center justify-center px-6 text-center">
          <p className="text-lg font-medium text-[#9a7b2f]">
            Loading service page...
          </p>
        </div>
<Footer showCta />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white">
       <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={pageDescription} />
      <meta name="robots" content={robotsContent} />
<meta name="googlebot" content={robotsContent} />
      <link rel="canonical" href={canonicalUrl} />

      <meta property="og:type" content="website" />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={pageImage} />
      <meta property="og:image:alt" content={pageImageAlt} />
      <meta property="og:site_name" content="G1 Gold Company" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageDescription} />
      <meta name="twitter:image" content={pageImage} />
      <meta name="twitter:image:alt" content={pageImageAlt} />
    </Helmet>

   {currentSchema
  .filter((schema) => schema?.["@type"] !== "FAQPage")
  .map((schema, i) => (
    <script
      key={i}
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  ))}
     


      <Header />

      <main>
        <section className="relative overflow-hidden bg-[#081225]">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(212,175,55,0.16),transparent_38%),radial-gradient(circle_at_bottom_right,rgba(212,175,55,0.1),transparent_30%)]" />

          <div className="relative mx-auto max-w-[1600px] px-6 py-14 lg:px-14 lg:py-16">
            <div className="grid items-center gap-10 lg:grid-cols-[1.05fr_0.95fr]">
              <div className="max-w-3xl">
                <span className="inline-flex items-center rounded-full border border-[#c89b2b]/30 bg-[#c89b2b]/10 px-4 py-2 text-[11px] font-semibold uppercase tracking-[0.2em] text-[#f4d16b]">
                  {service.badge || "Affiliated with Indian Gold Buyers"}
                </span>

                <h1 className="mt-5 max-w-2xl text-[32px] font-bold leading-[1.08] text-white sm:text-[38px] lg:text-[46px]">
                  {service.title}
                </h1>
{mobileHeroDescription ? (
  <>
    {/* MOBILE ONLY */}
    <p className="mt-4 max-w-2xl text-[14px] leading-6 text-white/80 sm:hidden">
      {mobileHeroDescription}
    </p>

    {/* TABLET + DESKTOP ONLY */}
    <p
      className="mt-5 hidden max-w-2xl text-[15px] leading-7 text-white/80 sm:block sm:text-base"
      dangerouslySetInnerHTML={{
        __html: service?.bannerDescription || "",
      }}
    />
  </>
) : (
  <p
    className="mt-5 max-w-2xl text-[15px] leading-7 text-white/80 sm:text-base"
    dangerouslySetInnerHTML={{
      __html: service?.bannerDescription || "",
    }}
  />
)}

<div className="mt-7 flex flex-col items-start gap-4 sm:flex-row sm:flex-wrap sm:items-center sm:gap-x-8 sm:gap-y-4">
{(slug === "sell-gold-from-home"
  ? ["Doorstep Service", "Home Testing", "Easy Selling"]
  : slug === "release-pledged-gold"
  ? ["Gold Loan Closure", "Pledged Gold Release", "Quick Payment Support"]
  : slug === "stone-value-for-your-gold"
  ? ["Gold Price", "Stone Value", "Clear Valuation"]
  : ["Transparent process", "Fair valuation", "Trusted support"]
).map(
    (label, index) => (
  <div key={index} className="flex w-full items-center gap-3 sm:w-auto">
        <span className="flex h-6 w-6 flex-shrink-0 items-center justify-center text-[#f4d16b]">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M20 6L9 17l-5-5" />
          </svg>
        </span>

        <span className="text-[18px] font-bold leading-none text-white sm:text-[20px]">
          {label}
        </span>
      </div>
    )
  )}
</div>

       <div className="mt-8 flex w-full justify-start">
  <div className="w-full max-w-[360px] rounded-[26px] border border-white/10 bg-white/10 p-3 shadow-[0_18px_45px_rgba(0,0,0,0.28)] backdrop-blur-md">
<a
  href="#gold-value-contact-section"
  onClick={(e) => {
    e.preventDefault();
    e.stopPropagation();

    const section = document.getElementById("gold-value-contact-section");

    if (section) {
      const headerOffset = 120;
      const sectionPosition =
        section.getBoundingClientRect().top + window.pageYOffset;

      window.scrollTo({
        top: sectionPosition - headerOffset,
        behavior: "smooth",
      });
    }
  }}
  className="group relative inline-flex min-h-[66px] w-full items-center justify-center overflow-hidden rounded-[15px] px-8 py-4 text-center text-[18px] font-bold text-[#081225] shadow-[0_12px_30px_rgba(239,203,87,0.30)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_18px_42px_rgba(239,203,87,0.45)]"
  style={{
    background: "linear-gradient(135deg, #F6DA6C 0%, #D8A91F 100%)",
  }}
>
  <span className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/35 to-transparent transition-transform duration-700 group-hover:translate-x-full" />
  <span className="relative">Sell Gold Now</span>
</a>
  </div>
</div>

              </div>

              <div className="overflow-hidden rounded-[28px] border border-white/10 bg-white/5 shadow-[0_20px_50px_rgba(0,0,0,0.25)]">
{slug === "convert-old-gold-to-new-gold" ? (
  <div className="h-[420px] w-full overflow-hidden rounded-[28px] border border-[#d7a51f]/35 shadow-[0_20px_50px_rgba(0,0,0,0.25)] lg:h-[520px]">
    <img
      src="/images/service/convert.webp"
      alt="Convert old gold into new jewellery"
      className="h-full w-full object-cover object-center"
      loading="lazy"
      onError={(e) => {
        e.currentTarget.onerror = null;
        e.currentTarget.src = "/images/service/convert-old-gold-to-new-gold-2.webp";
      }}
    />
  </div>
) : (
 <img
  src={
    service?.slug === "pledged-gold-buyers-in-bangalore" &&
    service?.bannerImage
      ? service.bannerImage
      : serviceImages[0]
  }
alt={
  service?.pageType === "releasePledgedGoldLocation"
    ? service?.ogImageAlt ||
      service?.title ||
      "Release pledged gold with G1 Gold"
    : service?.slug === "pledged-gold-buyers-in-bangalore" &&
      service?.bannerImageAlt
    ? service.bannerImageAlt
    : serviceImageAltMap[slug]?.[0] || service.title
}
  className={
    slug === "release-pledged-gold"
      ? "h-auto w-full object-cover object-center sm:h-[420px] lg:h-[520px]"
      : "h-[420px] w-full object-cover lg:h-[520px]"
  }
/>
)}
              </div>
            </div>
          </div>
        </section>
   {slug === "convert-old-gold-to-new-gold" && (
  <>
    <ConvertOldGoldValueSection />
    <ConvertOldGoldWhyChooseSection />
       <ConvertOldGoldWhoCanUseSection />
         <ConvertOldGoldHowItWorksSection />
  </>
)}

        {slug === "refer-and-earn" && (
  <ReferAndEarnProcessDesign />
)}
{slug === "refer-and-earn" && (
  <ReferAndEarnJoinBenefitsDesign serviceImages={serviceImages} />
)}
{slug === "stone-value-for-your-gold" && (
  <StoneValueHeroProcessDesign serviceImages={serviceImages} />
)}
    
{slug !== "convert-old-gold-to-new-gold" &&
  service.sections?.map((section, index) => {
const sectionHeading = section.heading?.trim().toLowerCase() || "";

if (slug === "release-pledged-gold") {
  if (index === 0) {
    return (
      <React.Fragment key="release-pledged-gold-custom-sections">
  <ReleasePledgedGoldWhyDesign
  section={section}
  serviceImages={serviceImages}
  serviceTitle={serviceImageAltMap[slug]?.[0] || service.title}
  processImageAlt={service?.processImageAlt}
/>
{isReleasePledgedGoldBangalorePage && (
  <ReleasePledgedGoldBangaloreSpecialDesign />
)}

{/* WHY CHOOSE */}
<ReleasePledgedGoldChooseDesign />

{/* LOAN OPTIONS - ONLY BANGALORE */}
{isReleasePledgedGoldBangalorePage && (
  <ReleasePledgedGoldLoanOptionsDesign />
)}

{/* SIMPLE PROCESS */}
<ReleasePledgedGoldProcessDesign
  serviceImages={serviceImages}
/>

{/* SEPARATE COMPARISON TABLE - ONLY BANGALORE */}
{isReleasePledgedGoldBangalorePage && (
  <ReleasePledgedGoldComparisonTable />
)}

      </React.Fragment>
    );
  }

  return null;
}
  
 if (section.heading?.trim() === "Why Choose G1 Gold Company") {
  if (slug !== "sell-gold-for-cash") {
    return null;
  }

  return (
    <section key={index} className="bg-white py-16">
      <div className="mx-auto max-w-[1600px] px-6 lg:px-14">
        <div className="relative overflow-hidden rounded-[34px] border border-[#e7c56b] bg-gradient-to-br from-[#fffaf0] via-white to-[#fff4d7] p-6 shadow-[0_24px_70px_rgba(20,33,61,0.08)] md:p-9 lg:p-11">
          
          {/* soft background glow */}
          <div className="pointer-events-none absolute -left-28 -top-28 h-72 w-72 rounded-full bg-[#f4d16b]/20 blur-[90px]" />
          <div className="pointer-events-none absolute -right-28 -bottom-28 h-72 w-72 rounded-full bg-[#c89418]/14 blur-[90px]" />

          <div className="relative grid items-center gap-10 lg:grid-cols-[0.92fr_1.08fr]">
            
            {/* Left Content */}
            <div>
              <p className="text-[11px] font-bold uppercase tracking-[0.35em] text-[#b98512]">
                Safe, Convenient, Trusted
              </p>

              <h2 className="mt-5 max-w-xl text-[30px] font-bold leading-tight text-[#111b3a] sm:text-[38px] lg:text-[44px]">
                Sell Gold for Cash with a{" "}
                <span className="text-[#c89214]">
                  Safe and Transparent Process
                </span>
              </h2>

              <p className="mt-5 max-w-xl text-[15px] font-medium leading-8 text-[#34405a] sm:text-base">
             At G1 Gold, we make it easy to sell gold for cash with a process that is safe, clear, and comfortable. From the moment you bring your gold, our team checks the purity, weighs it in front of you, and explains the value step by step. We do not rush your decision or hide any charges, so you can understand the final gold value before you sell.
              </p>

              <p className="mt-5 max-w-xl text-[15px] font-medium leading-8 text-[#34405a] sm:text-base">
    Many customers sell gold for urgent needs, unused jewellery, or better returns. That is why G1 Gold focuses on fair pricing, quick service, and honest support. Whether you want to sell gold for best value or sell gold for quick payment, we help you complete the process smoothly. As trusted gold buyers for cash, we also provide instant payment for customers looking for reliable gold buyers for instant cash.
              </p>

              {/* Bottom Points */}
            {/* Bottom Points */}
{/* Bottom Points */}
<div className="mt-8 grid gap-4 sm:grid-cols-3">
  {[
    "Clear Evaluation",
    "Purity Check",
    "Instant Payment",
  ].map((title, pointIndex) => (
    <div
      key={pointIndex}
      className="group flex items-center gap-3"
    >
      {/* Tick Icon */}
      <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-[#f4d16b] to-[#c89214] text-white shadow-[0_8px_18px_rgba(198,146,24,0.22)] transition-all duration-300 group-hover:scale-110">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-4 w-4"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M20 6L9 17l-5-5" />
        </svg>
      </span>

      <p className="text-left text-[15px] font-semibold leading-6 text-[#111b3a]">
        {title}
      </p>
    </div>
  ))}
</div>
            </div>

            {/* Right Image */}
            <div className="relative overflow-hidden rounded-[18px] bg-white shadow-[0_18px_55px_rgba(20,33,61,0.12)]">
              <img
                src={serviceImages[1] || serviceImages[0]}
                alt="Sell gold for cash with clear testing and instant payment"
                className="h-[300px] w-full object-cover sm:h-[420px] lg:h-[470px]"
              />

              <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-[#081225]/12 via-transparent to-transparent" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
if (
  slug === "sell-gold-from-home" &&
  section.heading?.toLowerCase().includes("home works")
) {
  return (
    <SellGoldFromHomeDetailsDesign
      key={index}
      serviceImages={serviceImages}
      serviceTitle={serviceImageAltMap[slug]?.[0] || service.title}
    />
  );
}



if (
  slug === "sell-gold-from-home" &&
  section.heading?.toLowerCase().includes("why sell gold from home")
) {
  return (
    <SellGoldFromHomeWhyDesign
      key={index}
      serviceImages={serviceImages}
    />
  );
}
if (
  slug === "sell-gold-from-home" &&
  section.heading?.toLowerCase().includes("what types of gold")
) {
  return (
    <SellGoldFromHomeTypesDesign
      key={index}
      section={section}
      serviceImages={serviceImages}
    />
  );
}
if (
  slug === "sell-gold-from-home" &&
  (
    section.heading?.toLowerCase().includes("is it safe to sell gold from home") ||
    section.heading?.toLowerCase().includes("who can use")
  )
) {
  return null;
}

if (
  slug === "stone-value-for-your-gold" &&
  (
    section.heading?.toLowerCase().includes("stone value in gold jewellery is checked") ||
    section.heading?.toLowerCase().includes("benefits of including stone value") ||
    section.heading?.toLowerCase().includes("who can use g1 gold")
  )
) {
  return null;
}
if (
  slug === "refer-and-earn" &&
  (
    section.heading?.toLowerCase().includes("refer & earn program works") ||
    section.heading?.toLowerCase().includes("refer and earn program works") ||
    section.heading?.toLowerCase().includes("why join our refer")
  )
) {
  return null;
}
const darkSection = index % 2 === 1;
const isHowItWorksSection = section.heading === "How It Works";

const isReleasePledgedWhySection =
  slug === "release-pledged-gold" &&
  section.heading?.toLowerCase().includes("pledged gold release");

const isStoneValueFirstSection =
  slug === "stone-value-for-your-gold" &&
  index === 0 &&
  section.heading?.trim() === "Why Choose Our Stone Value Service?";

const useGoldShowcaseCards =
  section.items &&
  section.heading?.trim().toLowerCase() === "types of gold we buy";
  

    return (
  <React.Fragment key={index}>
    <section
      className={
        isHowItWorksSection
          ? "bg-[#fff8ea] py-0"
          : darkSection
          ? "bg-[#0b1730] py-16"
          : "bg-white py-16"
      }
    >
           <div
  className={
    isHowItWorksSection
      ? "mx-auto max-w-none px-0"
      : "mx-auto max-w-[1600px] px-6 lg:px-14"
  }
>
                {!isHowItWorksSection && (
  <div
  className={`mb-10 ${
    isReleasePledgedWhySection
      ? "mx-auto max-w-5xl text-center"
      : "max-w-4xl"
  }`}
>
    <p
      className={`text-[11px] font-semibold uppercase tracking-[0.2em] ${
        darkSection ? "text-[#f4d16b]" : "text-[#b68b22]"
      }`}
    >
      Service Details
    </p>

 <h2
  className={
    isReleasePledgedWhySection
      ? "mt-3 font-serif text-[34px] font-bold leading-tight text-[#081225] md:text-[44px]"
      : `mt-3 text-3xl font-bold md:text-4xl ${
          darkSection ? "text-white" : "text-[#14213d]"
        }`
  }
>
  {section.heading}
</h2>

{isReleasePledgedWhySection && (
  <div className="mx-auto mt-5 flex items-center justify-center gap-2">
    <span className="h-[2px] w-16 rounded-full bg-[#d7a51f]/40" />
    <span className="h-[3px] w-12 rounded-full bg-[#d7a51f]" />
    <span className="h-[2px] w-16 rounded-full bg-[#d7a51f]/40" />
  </div>
)}

    {section.description && (
      <p
        className={`mt-4 max-w-4xl text-base leading-8 ${
          darkSection ? "text-white/75" : "text-gray-600"
        }`}
      >
        {section.description}
      </p>
    )}
  </div>
)}

            {section.items && (
  useGoldShowcaseCards ? (
    <ServiceItemCards
      section={section}
      serviceImages={serviceImages}
      slug={slug}
      serviceTitle={service.title}
    />
  ) : section.heading === "Why Choose G1 Gold Company" ? (
  <div className="relative overflow-hidden rounded-[34px] border border-[#ead8a8] bg-gradient-to-br from-[#fffaf0] via-white to-[#fff3cf] p-5 shadow-[0_22px_70px_rgba(20,33,61,0.08)] sm:p-7 lg:p-8">
    {/* background glow */}
    <div className="pointer-events-none absolute -left-24 -top-24 h-72 w-72 rounded-full bg-[#f4d16b]/25 blur-[90px]" />
    <div className="pointer-events-none absolute -right-24 -bottom-24 h-72 w-72 rounded-full bg-[#c89418]/15 blur-[90px]" />

    <div className="relative grid gap-8 lg:grid-cols-[0.85fr_1.15fr]">
      {/* Left Side List */}
      <div className="rounded-[28px] border border-[#ead8a8] bg-white/75 p-4 shadow-[0_18px_45px_rgba(20,33,61,0.06)] backdrop-blur-sm">
        <div className="space-y-4">
          {section.items.map((item, itemIndex) => {
            const whyChooseIcons = [
              serviceIcons.payment,
              serviceIcons.purity,
              serviceIcons.pricing,
              serviceIcons.valuation,
              serviceIcons.shield,
              serviceIcons.expert,
            ];

            const isActive = activeWhyIndex === itemIndex;

            return (
              <button
                key={itemIndex}
                type="button"
                onClick={() => setActiveWhyIndex(itemIndex)}
                className={`group flex w-full items-center gap-4 rounded-[22px] border p-4 text-left transition-all duration-300 ${
                  isActive
                    ? "border-[#d7a51f] bg-[#fffaf0] shadow-[0_14px_32px_rgba(198,146,24,0.16)]"
                    : "border-[#ead8a8]/75 bg-white hover:border-[#d7a51f] hover:bg-[#fffaf0]"
                }`}
              >
                <span
                  className={`flex h-[54px] w-[54px] shrink-0 items-center justify-center rounded-full border transition-all duration-300 ${
                    isActive
                      ? "border-[#d7a51f] bg-[#fff0b9] text-[#8a5a00]"
                      : "border-[#ead8a8] bg-[#fffaf0] text-[#b98512]"
                  }`}
                >
                  {whyChooseIcons[itemIndex] ||
                    getServiceItemIcon(item.title, item.description)}
                </span>

                <span className="min-w-0 flex-1">
                  <span
                    className={`block text-[17px] font-bold leading-snug ${
                      isActive ? "text-[#081225]" : "text-[#1f2a44]"
                    }`}
                  >
                    {item.title}
                  </span>

                  <span className="mt-1 block text-[13px] font-medium text-[#707782]">
                    Click to view details
                  </span>
                </span>

                <span
                  className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-[22px] font-bold transition-all duration-300 ${
                    isActive
                      ? "bg-[#d7a51f] text-white"
                      : "bg-[#fff0b9] text-[#b98512] group-hover:bg-[#d7a51f] group-hover:text-white"
                  }`}
                >
                  ›
                </span>
              </button>
            );
          })}
        </div>
      </div>

      {/* Right Side Detail Card */}
      {(() => {
        const activeItem = section.items[activeWhyIndex] || section.items[0];

        const whyChooseIcons = [
          serviceIcons.payment,
          serviceIcons.purity,
          serviceIcons.pricing,
          serviceIcons.valuation,
          serviceIcons.shield,
          serviceIcons.expert,
        ];

        return (
          <div className="relative overflow-hidden rounded-[32px] border border-[#ead8a8] bg-gradient-to-br from-white via-[#fffdf7] to-[#fff2cf] p-6 shadow-[0_18px_55px_rgba(20,33,61,0.08)] sm:p-8 lg:p-10">
            {/* soft glow */}
            <div className="pointer-events-none absolute -right-20 -top-20 h-64 w-64 rounded-full bg-[#f4d16b]/25 blur-[80px]" />
            <div className="pointer-events-none absolute -bottom-24 -left-24 h-64 w-64 rounded-full bg-[#c89418]/10 blur-[80px]" />
<div className="relative max-w-3xl">
  <span className="inline-flex rounded-full border border-[#d7a51f]/50 bg-[#fff1bd] px-5 py-2 text-[11px] font-bold uppercase tracking-[0.25em] text-[#b98512]">
    Why Choose Us
  </span>

  <h3 className="mt-6 max-w-2xl font-serif text-[38px] font-bold leading-[1.08] text-[#111b3a] md:text-[50px]">
    {activeItem.title}
  </h3>

  <div className="mt-5 h-[3px] w-20 rounded-full bg-[#d7a51f]" />

  <p className="mt-7 max-w-2xl text-[17px] font-semibold leading-9 text-[#5f6572]">
    {activeItem.description}
  </p>
</div>
        
          </div>
        );
      })()}
    </div>
  </div>
) : slug === "sell-gold-from-home" &&
    section.heading?.toLowerCase().includes("home works") ? (
  <div className="relative mt-6 overflow-hidden rounded-[34px] border border-[#ead8a8] bg-gradient-to-br from-[#fffdf8] via-white to-[#fff7e4] px-6 py-14 shadow-[0_24px_70px_rgba(20,33,61,0.06)] lg:px-8">
    {/* soft premium background */}
    <div className="pointer-events-none absolute -left-24 -top-24 h-72 w-72 rounded-full bg-[#f4d16b]/20 blur-[90px]" />
    <div className="pointer-events-none absolute -right-24 -bottom-24 h-72 w-72 rounded-full bg-[#d7a51f]/14 blur-[90px]" />

    {/* desktop connector line */}
    <div className="pointer-events-none absolute left-[18%] right-[18%] top-1/2 hidden h-[3px] -translate-y-1/2 bg-gradient-to-r from-transparent via-[#d7a51f]/75 to-transparent xl:block" />

    <div className="relative grid gap-10 ">
      {section.items.map((item, itemIndex) => {
        const homeStepIcons = [
          // Step 1: calendar check
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <rect x="3" y="5" width="14" height="14" rx="2" />
            <path d="M7 3v4" />
            <path d="M13 3v4" />
            <path d="M3 9h14" />
            <path d="M7 13h.01" />
            <path d="M11 13h.01" />
            <path d="M7 17h.01" />
            <circle cx="18" cy="17" r="4" />
            <path d="M16.4 17l1.1 1.1 2.2-2.5" />
          </svg>,

          // Step 2: home valuation
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M4 11l8-7 8 7" />
            <path d="M6 10v10h6" />
            <path d="M18 14a4 4 0 1 1-2.8-1.15" />
            <path d="M18.8 18.8L22 22" />
          </svg>,

          // Step 3: wallet payment
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M4 7h14a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7z" />
            <path d="M4 7l11-3 1 3" />
            <path d="M15 13h6" />
            <circle cx="18" cy="13" r="1" />
          </svg>,
        ];

        return (
          <div key={itemIndex} className="relative">
            {/* top number */}
            <div className="absolute left-1/2 top-0 z-20 flex h-[74px] w-[74px] -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-gradient-to-br from-[#f7dd77] via-[#d7a51f] to-[#b98210] text-[30px] font-bold text-white shadow-[0_16px_34px_rgba(198,146,24,0.35)] ring-[8px] ring-white">
              {String(itemIndex + 1).padStart(2, "0")}
            </div>

            {/* connector dot */}
            {itemIndex < section.items.length - 1 && (
              <div className="absolute -right-6 top-1/2 z-20 hidden h-7 w-7 -translate-y-1/2 rounded-full border-[6px] border-white bg-[#d7a51f] shadow-[0_10px_25px_rgba(198,146,24,0.28)] xl:block" />
            )}

            <div className="group relative min-h-[250px] overflow-hidden rounded-[26px] border border-[#d7a51f]/70 bg-white px-8 pb-8 pt-16 shadow-[0_20px_55px_rgba(20,33,61,0.07)] transition-all duration-500 hover:-translate-y-2 hover:border-[#c89214] hover:shadow-[0_32px_80px_rgba(198,146,24,0.16)]">
              {/* glow */}
              <div className="pointer-events-none absolute -right-20 -top-20 h-44 w-44 rounded-full bg-[#f4d16b]/0 blur-3xl transition-all duration-500 group-hover:bg-[#f4d16b]/25" />

              {/* top shine */}
              <div className="absolute left-0 top-0 h-[4px] w-0 bg-gradient-to-r from-[#f6da6c] to-[#c89214] transition-all duration-700 group-hover:w-full" />

              <div className="relative z-10 flex h-full items-center gap-8">
                {/* icon */}
                <div className="flex h-[116px] w-[116px] shrink-0 items-center justify-center rounded-[28px] bg-[#fff8ea] text-[#d4a12b] shadow-[inset_0_0_0_1px_rgba(215,165,31,0.35),0_14px_35px_rgba(198,146,24,0.10)]">
                  <div className="[&>svg]:h-[82px] [&>svg]:w-[82px]">
                    {homeStepIcons[itemIndex] ||
                      getServiceItemIcon(item.title, item.description)}
                  </div>
                </div>

                {/* content */}
                <div className="min-w-0 flex-1">
                  <h3 className="text-[22px] font-bold leading-snug text-[#081225]">
                    {item.title}
                  </h3>

                  <p className="mt-5 text-[16px] font-medium leading-8 text-[#34405a]">
                    {item.description}
                  </p>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  </div>
) : isStoneValueFirstSection ? (
  <div className="relative mx-auto max-w-[1320px]">
    <div className="grid gap-8 md:grid-cols-3">
      {section.items.map((item, itemIndex) => {
        const stoneValueImages = [
          `${process.env.PUBLIC_URL}/images/how-it-works/stone-complete.png`,
          `${process.env.PUBLIC_URL}/images/how-it-works/stone-breakup.png`,
          `${process.env.PUBLIC_URL}/images/how-it-works/stone-better-value.png`,
        ];

        return (
          <div
            key={itemIndex}
            className="group relative flex min-h-[360px] flex-col items-center rounded-[28px] border border-[#d7a51f]/60 bg-white px-8 pb-9 pt-8 text-center shadow-[0_16px_45px_rgba(20,33,61,0.06)] transition-all duration-300 hover:-translate-y-2 hover:border-[#c89214] hover:shadow-[0_28px_70px_rgba(198,146,24,0.14)]"
          >
            <div className="relative flex h-[120px] w-[120px] items-center justify-center rounded-full border border-[#d7a51f]/80 bg-gradient-to-br from-[#fff0bd] via-[#fff8df] to-white shadow-[inset_0_0_0_6px_rgba(255,255,255,0.85),0_16px_34px_rgba(198,146,24,0.18)]">
           <div className="absolute inset-[8px] rounded-full border border-dashed border-[#d7a51f]/70" />
<div className="absolute inset-[20px] rounded-full bg-[#fff1bd]/80" />

              <img
                src={stoneValueImages[itemIndex]}
                alt={item.title}
                className="relative z-10 h-[82px] w-[82px] scale-105 object-contain brightness-75 contrast-200 saturate-200 drop-shadow-[0_4px_3px_rgba(120,72,0,0.45)]"
              />
            </div>

            <h3 className="mt-7 max-w-[270px] font-serif text-[25px] font-bold leading-tight text-[#111b3a] md:text-[28px]">
              {item.title}
            </h3>

            <div className="mt-5 flex items-center justify-center gap-2">
              <span className="h-px w-12 bg-[#d7a51f]/55" />
              <span className="h-2 w-2 rotate-45 border border-[#d7a51f]" />
              <span className="h-px w-12 bg-[#d7a51f]/55" />
            </div>

            <p className="mt-5 max-w-[300px] text-[16px] font-medium leading-8 text-[#4b5567]">
              {item.description}
            </p>

            <div className="absolute -bottom-[6px] left-1/2 h-3 w-3 -translate-x-1/2 rotate-45 border border-[#d7a51f] bg-white" />
          </div>
        );
      })}
    </div>
  </div>
  
) : isReleasePledgedWhySection ? (
  <div className="mx-auto max-w-[1220px] space-y-6">
    {section.items.map((item, itemIndex) => {
     const releaseImages = [
  `${process.env.PUBLIC_URL}/images/how-it-works/release-trusted.png`,
  `${process.env.PUBLIC_URL}/images/how-it-works/release-valuation.png`,
  `${process.env.PUBLIC_URL}/images/how-it-works/release-payment.png`,
];

      return (
        <div
          key={itemIndex}
          className="group relative overflow-hidden rounded-[24px] border border-[#ead8a8] bg-white px-6 py-6 shadow-[0_14px_40px_rgba(20,33,61,0.06)] transition-all duration-300 hover:-translate-y-1 hover:border-[#d7a51f] hover:shadow-[0_24px_60px_rgba(198,146,24,0.14)] md:px-8"
        >
          {/* soft gold glow */}
          <div className="pointer-events-none absolute -right-20 -top-20 h-44 w-44 rounded-full bg-[#f4d16b]/0 blur-3xl transition-all duration-500 group-hover:bg-[#f4d16b]/20" />

          <div className="relative flex flex-col gap-6 md:flex-row md:items-center">
            {/* left icon */}
            <div className="flex justify-center md:w-[150px] md:justify-start">
           <div className="relative flex h-[112px] w-[112px] items-center justify-center rounded-full border border-[#d7a51f]/70 bg-gradient-to-br from-[#fff3c8] via-[#fffaf0] to-white shadow-[inset_0_0_0_8px_rgba(255,255,255,0.9),0_18px_38px_rgba(198,146,24,0.18)]">
  <div className="absolute inset-[11px] rounded-full border border-[#d7a51f]/60" />
  <div className="absolute inset-[23px] rounded-full bg-[#fff1bd]/80" />

  <img
    src={releaseImages[itemIndex]}
    alt={item.title}
    className="relative z-10 h-[84px] w-[84px] scale-110 object-contain brightness-90 contrast-200 saturate-200 drop-shadow-[0_4px_2px_rgba(126,82,0,0.50)]"
  />
</div>
            </div>

            {/* vertical divider */}
            <div className="hidden h-24 w-px bg-gradient-to-b from-transparent via-[#d7a51f]/60 to-transparent md:block" />

            {/* content */}
            <div className="min-w-0 flex-1 text-center md:text-left">
              <h3 className="font-serif text-[25px] font-bold leading-snug text-[#111b3a] md:text-[28px]">
                {item.title}
              </h3>

              <p className="mt-3 max-w-3xl text-[16px] font-medium leading-8 text-[#34405a]">
                {item.description}
              </p>
            </div>

            {/* right number */}
            <div className="flex justify-center md:w-[115px] md:justify-end">
              <div className="flex h-[70px] w-[70px] items-center justify-center rounded-full border-2 border-[#d7a51f] bg-white text-[28px] font-bold text-[#d7a51f] shadow-[0_12px_28px_rgba(198,146,24,0.12)]">
                {String(itemIndex + 1).padStart(2, "0")}
              </div>
            </div>
          </div>
        </div>
      );
    })}
  </div>
) : (

  <div
    className={`grid gap-6 md:grid-cols-2 ${
      section.items.length === 4 ? "xl:grid-cols-2" : "xl:grid-cols-6"
    }`}
  >
    {section.items.map((item, itemIndex) => {
      const totalItems = section.items.length;
      const isFourItems = totalItems === 4;
      const lastRowCount = totalItems % 3;

      const centerClass =
        !isFourItems && lastRowCount === 1 && itemIndex === totalItems - 1
          ? "xl:col-start-3"
          : !isFourItems && lastRowCount === 2 && itemIndex === totalItems - 2
          ? "xl:col-start-2"
          : "";

      return (
        <div
          key={itemIndex}
          className={`${isFourItems ? "" : "xl:col-span-2"} ${centerClass} flex h-full flex-col rounded-3xl border p-7 shadow-sm transition hover:-translate-y-1 hover:shadow-lg ${
            darkSection
              ? "border-white/10 bg-white/5"
              : "border-[#f1e7c8] bg-white"
          }`}
        >
          <div
            className="mb-5 flex h-12 w-12 md:h-14 md:w-14 items-center justify-center rounded-2xl text-white shadow-lg"
            style={goldGradient}
          >
            {getServiceItemIcon(item.title, item.description)}
          </div>

          <h3
            className={`min-h-[56px] text-lg font-semibold leading-snug ${
              darkSection ? "text-white" : "text-[#14213d]"
            }`}
          >
            {item.title}
          </h3>

          <p
            className={`mt-3 flex-1 text-sm leading-7 ${
              darkSection ? "text-white/75" : "text-gray-600"
            }`}
          >
            {item.description}
          </p>
            </div>
      );
    })}
  </div>
)
)}

            {section.list && (
section.heading === "How It Works" ? (
 <div className="relative w-full overflow-hidden border-y border-[#ead8a8] bg-[#fff8ea]">
    {/* premium background */}
    <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(244,209,107,0.28),transparent_28%),radial-gradient(circle_at_bottom_right,rgba(200,148,24,0.20),transparent_30%)]" />
    <div className="pointer-events-none absolute -left-32 -top-32 h-80 w-80 rounded-full border border-[#d7a51f]/30" />
    <div className="pointer-events-none absolute -right-32 -bottom-32 h-80 w-80 rounded-full border border-[#d7a51f]/30" />

    <div className="relative mx-auto max-w-[1600px] px-6 py-16 lg:px-14 lg:py-20">
      <div className="grid gap-14 lg:grid-cols-[0.72fr_1.28fr] lg:items-center">
        {/* Left Premium Content */}
        <div className="relative">
          <p className="text-[12px] font-bold uppercase tracking-[0.35em] text-[#b98512]">
            Simple Process
          </p>

          <h3 className="mt-5 font-serif text-[46px] font-bold leading-[1.05] text-[#081225] md:text-[64px]">
            How It  Works
          </h3>

          <div className="mt-7 inline-flex items-center gap-4 rounded-full border border-[#ead8a8] bg-white/70 px-5 py-3 shadow-[0_14px_35px_rgba(20,33,61,0.06)] backdrop-blur-sm">
            <span className="flex h-11 w-11 items-center justify-center rounded-full bg-gradient-to-br from-[#f6da6c] to-[#c89214] text-white shadow-[0_14px_30px_rgba(200,155,43,0.35)]">
              ✓
            </span>

            <span className="text-[13px] font-bold uppercase tracking-[0.22em] text-[#b98512]">
              Transparent Gold Selling
            </span>
          </div>

          <h4 className="mt-8 max-w-lg font-serif text-[34px] font-bold leading-[1.15] text-[#081225] md:text-[42px]">
            Fast Testing, Clear Price, Instant Payment
          </h4>

          <p className="mt-6 max-w-lg text-[17px] font-medium leading-9 text-[#34405a]">
            Follow these simple steps to sell your gold with clear checking,
            fair valuation, and quick settlement.
          </p>

          <div className="mt-12 hidden lg:block">
            <div className="relative w-fit">
              <div className="absolute inset-0 rounded-full bg-[#f4d16b]/35 blur-3xl" />

              <img
                src={`${process.env.PUBLIC_URL}/images/how-it-works/thumbnail.png`}
                alt="Bring your gold"
                className="relative h-[230px] w-[330px] object-contain drop-shadow-[0_26px_40px_rgba(148,99,0,0.22)]"
              />
            </div>
          </div>
        </div>

        {/* Right Premium Timeline */}
        <div className="relative">
          {/* dotted connector line */}
          <svg
            className="pointer-events-none absolute left-[13%] top-[72px] hidden h-[620px] w-[74%] xl:block"
            viewBox="0 0 760 620"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M150 25 C150 120 320 100 320 205 C320 320 90 280 90 400 C90 540 500 420 615 585"
              stroke="#d7a51f"
              strokeWidth="2"
              strokeDasharray="8 10"
            />
            <circle cx="320" cy="205" r="5" fill="#d7a51f" />
            <circle cx="90" cy="400" r="5" fill="#d7a51f" />
            <circle cx="615" cy="585" r="5" fill="#d7a51f" />
          </svg>

          <div className="space-y-8">
            {section.list.map((point, pointIndex) => {
              const processTitles = [
                "Bring Your Gold",
                "Purity Testing",
                "Price Confirmation",
                "Instant Payment",
              ];

              const processImages = [
                `${process.env.PUBLIC_URL}/images/how-it-works/bring.png`,
                `${process.env.PUBLIC_URL}/images/how-it-works/get.png`,
                `${process.env.PUBLIC_URL}/images/how-it-works/clear.png`,
                `${process.env.PUBLIC_URL}/images/how-it-works/free.png`,
              ];

              const cardShift =
                pointIndex === 0
                  ? "xl:ml-[70px]"
                  : pointIndex === 1
                  ? "xl:ml-auto"
                  : pointIndex === 2
                  ? "xl:ml-[20px]"
                  : "xl:ml-auto";

              return (
                <div
                  key={pointIndex}
                  className={`group relative max-w-[560px] ${cardShift}`}
                >
                  {/* number badge */}
               <div className="absolute left-1/2 top-0 z-20 flex h-[54px] w-[54px] -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full border-4 border-[#fff8ea] bg-gradient-to-br from-[#f6da6c] to-[#c89214] text-[18px] font-bold text-white shadow-[0_18px_40px_rgba(198,146,24,0.38)] lg:-left-5 lg:top-1/2 lg:h-[62px] lg:w-[62px] lg:translate-x-0 lg:-translate-y-1/2 lg:text-[22px]">
  {String(pointIndex + 1).padStart(2, "0")}
</div>

                  <div className="relative overflow-hidden rounded-[28px] border border-[#ead8a8] bg-white/95 px-5 pb-7 pt-10 shadow-[0_22px_60px_rgba(20,33,61,0.08)] backdrop-blur-sm transition-all duration-500 hover:-translate-y-2 hover:border-[#d7a51f] hover:shadow-[0_32px_85px_rgba(198,146,24,0.18)] lg:px-6 lg:py-7 lg:pl-16">
                    {/* right gold bar */}
                    <div className="absolute right-0 top-5 h-[calc(100%-40px)] w-[6px] rounded-l-full bg-gradient-to-b from-[#f6da6c] to-[#c89214]" />

                    {/* hover glow */}
                    <div className="pointer-events-none absolute -right-20 -top-20 h-48 w-48 rounded-full bg-[#f4d16b]/0 blur-3xl transition-all duration-500 group-hover:bg-[#f4d16b]/25" />

                <div className="relative z-10 flex flex-col items-center gap-4 text-center lg:flex-row lg:items-start lg:gap-5 lg:text-left">
                      {/* icon */}
                      <div className="flex h-[74px] w-[74px] shrink-0 items-center justify-center rounded-full border border-[#e7c36c] bg-[#fff8ea] shadow-[inset_0_0_0_8px_rgba(255,255,255,0.75),0_14px_30px_rgba(198,146,24,0.12)] lg:h-[84px] lg:w-[84px]">
                        <img
                          src={processImages[pointIndex] || processImages[0]}
                          alt={processTitles[pointIndex] || `Step ${pointIndex + 1}`}
                          className="h-[60px] w-[60px] object-contain transition-transform duration-500 group-hover:scale-110"
                        />
                      </div>

                      {/* text */}
                      <div className="min-w-0 flex-1">
                        <h3 className="text-[23px] font-bold leading-snug text-[#081225]">
                          {processTitles[pointIndex] || `Step ${pointIndex + 1}`}
                        </h3>

                        <p className="mt-3 text-[15px] font-medium leading-8 text-[#34405a]">
                          {point}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  </div>
) : (
    <div className="grid gap-5 md:grid-cols-2">
      {section.list.map((point, pointIndex) => (
        <div
          key={pointIndex}
          className={`flex gap-4 rounded-3xl border p-5 shadow-sm ${
            darkSection
              ? "border-white/10 bg-white/5"
              : "border-[#f1e7c8] bg-[#fffaf0]"
          }`}
        >
          <span
            className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-2xl text-sm font-bold text-white shadow-lg"
            style={goldGradient}
          >
            {pointIndex + 1}
          </span>

          <p
            className={`text-sm leading-7 ${
              darkSection ? "text-white/80" : "text-gray-700"
            }`}
          >
            {point}
          </p>
        </div>
      ))}
    </div>
  )
)}

              {index === 1 && !useGoldShowcaseCards && (
  <div className="mt-10 grid gap-6 md:grid-cols-2">
                    <div className="overflow-hidden rounded-[26px] border border-[#f1e7c8] bg-white shadow-sm">
                      <img
                        src={serviceImages[1]}
                      alt={serviceImageAltMap[slug]?.[1] || service.title}
                      
                        className="h-[280px] w-full object-cover"
                      />
                    </div>
                    <div className="overflow-hidden rounded-[26px] border border-[#f1e7c8] bg-white shadow-sm">
                      <img
                        src={serviceImages[2]}
          alt={serviceImageAltMap[slug]?.[2] || service.title}
                        className="h-[280px] w-full object-cover"
                      />
                    </div>
                  </div>
                )}
              </div>
              </section>

    {isStoneValueFirstSection && (
      <StoneValueSellingProcessDesign serviceImages={serviceImages} />
    )}
  </React.Fragment>
);
        })}
        
        

        
    


{/* SELL GOLD FOR CASH TRANSPARENT VALUATION SECTION */}

{(() => {
  const documentsToShow =
    service.documentsRequired?.length > 0
      ? service.documentsRequired
      : defaultDocumentsRequired;

  return (
    <section className="bg-[#fffaf0] py-12 md:py-16">
      <div className="mx-auto max-w-[1600px] px-4 sm:px-6 lg:px-14">
        
        <DocumentsContactStrip slug={slug} serviceTitle={service.title} />

        <div className="mb-10 max-w-3xl">
          <p className="text-[11px] font-semibold uppercase tracking-[0.25em] text-[#b68b22]">
            Required Details
          </p>

          <h2 className="mt-3 text-3xl font-bold text-[#061f3f] md:text-4xl">
            Documents Required
          </h2>

          <p className="mt-4 text-base leading-8 text-[#334155]">
            Please keep the following documents ready for a smoother and faster process.
          </p>
        </div>

       <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-6 xl:grid-cols-4">
          {documentsToShow.map((doc, index) => {
            const cardBg = getDocumentCardImage(doc, slug, index);
            const isInvoiceDoc = doc.toLowerCase().includes("invoice");

            return (
              <div
                key={index}
className="group mx-auto w-full max-w-[370px] overflow-hidden rounded-xl border border-[#e3d3a2] bg-white shadow-[0_10px_28px_rgba(0,0,0,0.08)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_16px_36px_rgba(0,0,0,0.12)] sm:max-w-none"
              >
                <div className="relative bg-gradient-to-br from-[#fffdf7] via-[#fbf4df] to-[#f2e5bf] p-3">
                  <div className="flex h-[205px] items-center justify-center border border-[#e8d7a8] bg-white p-2 sm:h-[235px] md:h-[250px] xl:h-[240px]">
                    <img
                      src={cardBg}
                      alt={doc}
           className={`h-full w-full object-contain object-center transition-transform duration-300 group-hover:scale-[1.03] ${
  isInvoiceDoc ? "scale-[1.18] sm:scale-[1.28]" : "scale-100 sm:scale-100"
}`}         />
                  </div>
                </div>

          <div className="border-t border-[#eee1bd] bg-white px-4 py-4 sm:px-5 sm:py-5">
  <p className="text-[15px] font-semibold leading-snug text-[#061f3f] sm:text-lg">
                    {doc}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
})()}
   <section className="relative overflow-hidden bg-[#081225] py-16">
          <div className="absolute inset-0 bg-gradient-to-r from-[#081225] via-[#0e1c35] to-[#081225]" />
          <div className="relative mx-auto flex max-w-[1600px] flex-col items-start justify-between gap-8 px-6 lg:flex-row lg:items-center lg:px-14">
            <div className="max-w-3xl">
              <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-[#f4d16b]">
                Get Started Today
              </p>
              <h2 className="mt-3 text-3xl font-bold text-white md:text-4xl">
                Ready to proceed with {service.title.toLowerCase()}?
              </h2>
              <p className="mt-4 max-w-2xl text-base leading-8 text-white/80">
                Connect with our team for transparent guidance, quick support, and a hassle-free experience.
              </p>
            </div>

            <div className="flex flex-wrap gap-4">
              <a
                href="https://g1gold.com/contact"
                className="rounded-2xl px-8 py-4 text-sm font-semibold text-white shadow-lg transition hover:scale-[1.02]"
                style={primaryButtonStyle}
              >
                Contact Us
              </a>
              <a
  href="https://g1gold.com/services"
  className="rounded-2xl border border-white/20 bg-white/10 px-8 py-4 text-sm font-semibold text-white transition hover:bg-white/15"
>
  Back to Services
</a>
            </div>
          </div>
        </section>

{service.faqs?.length > 0 && (
  <section className="relative overflow-hidden bg-[#fffaf0] py-16 lg:py-20">
    {/* soft corner circles */}
    <div className="pointer-events-none absolute left-[-120px] top-[-130px] h-[300px] w-[300px] rounded-full border border-[#d7a51f]/25" />
    <div className="pointer-events-none absolute right-[-120px] top-[-120px] h-[300px] w-[300px] rounded-full border border-[#d7a51f]/20" />

    <div className="relative mx-auto max-w-[1450px] px-5 sm:px-6 lg:px-10">
      {/* Heading */}
      <div className="mx-auto max-w-5xl text-center">
        <div className="flex items-center justify-center gap-4">
          <span className="h-px w-10 bg-[#c79211]" />
          <p className="text-[12px] font-bold uppercase tracking-[0.34em] text-[#b98512]">
            FAQ
          </p>
          <span className="h-px w-10 bg-[#c79211]" />
        </div>

        <h2 className="mt-6 font-serif text-[36px] font-bold leading-tight text-[#111827] sm:text-[48px] lg:text-[62px]">
          Frequently Asked{" "}
          <span className="text-[#b98512]">Questions</span>
        </h2>

        <div className="mx-auto mt-5 flex w-[220px] items-center justify-center gap-3">
          <span className="h-px flex-1 bg-[#d7a51f]" />
          <span className="h-2 w-2 rotate-45 border border-[#d7a51f]" />
          <span className="h-2 w-2 rotate-45 border border-[#d7a51f]" />
          <span className="h-px flex-1 bg-[#d7a51f]" />
        </div>

        <p className="mx-auto mt-7 max-w-3xl text-[17px] font-medium leading-8 text-[#334155] sm:text-[18px]">
          Find quick answers to common questions about this service.
        </p>
      </div>

      {/* FAQ Cards */}
      <div className="mx-auto mt-14 max-w-[1180px] space-y-5">
        {visibleFaqs.map((faq, index) => {
          const isOpen = openFaqIndex === index;
          const number = String(index + 1).padStart(2, "0");

          return (
            <div
              key={index}
              className={`overflow-hidden rounded-[20px] border border-[#e2c56f] bg-white transition-all duration-300 ${
                isOpen
                  ? "shadow-[0_18px_45px_rgba(20,33,61,0.08)]"
                  : "shadow-[0_10px_28px_rgba(20,33,61,0.04)]"
              }`}
            >
              {isOpen ? (
                <div className="grid grid-cols-1 sm:grid-cols-[165px_1fr]">
                  {/* LEFT GOLD BLOCK */}
                  <div className="flex min-h-[190px] flex-col items-center justify-center bg-gradient-to-br from-[#f7d66a] via-[#d7a51f] to-[#c48607] px-5 py-8 text-center">
                    <span className="flex h-[70px] w-[70px] items-center justify-center rounded-full bg-white text-[#c79211] shadow-[0_8px_18px_rgba(0,0,0,0.08)]">
                      <svg
                        viewBox="0 0 24 24"
                        className="h-8 w-8"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M21 15a4 4 0 0 1-4 4H8l-5 3V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4z" />
                        <path d="M8 9h8" />
                        <path d="M8 13h5" />
                      </svg>
                    </span>

                    <span className="mt-6 h-px w-[60px] bg-white/85" />

                    <span className="mt-5 font-serif text-[26px] font-bold tracking-[0.06em] text-white">
                      {number}
                    </span>
                  </div>

                  {/* RIGHT ANSWER BLOCK */}
                {/* RIGHT IMAGE */}
{/* RIGHT ANSWER BLOCK */}
<div className="relative flex min-h-[190px] flex-col justify-center px-5 py-6 sm:px-8 lg:px-10">
  <button
    type="button"
    onClick={() => setOpenFaqIndex(null)}
    className="absolute right-4 top-4 flex h-9 w-9 items-center justify-center rounded-full border border-[#d7a51f] text-[24px] font-light leading-none text-[#b98512] transition hover:bg-[#fff3d5]"
    aria-label="Close FAQ"
  >
    −
  </button>

  <h3 className="pr-12 text-[18px] font-extrabold leading-snug text-[#06152f] sm:text-[21px] lg:text-[24px]">
    {faq.question}
  </h3>

  <p className="mt-4 max-w-4xl text-[14px] font-medium leading-7 text-[#334155] sm:text-[16px] sm:leading-8">
    {faq.answer || faq.description}
  </p>
</div>
                </div>
              ) : (
                <button
                  type="button"
                  onClick={() => setOpenFaqIndex(index)}
                  className="flex w-full items-center justify-between gap-5 px-5 py-5 text-left sm:px-7 sm:py-6 lg:px-8"
                >
                  <div className="flex min-w-0 items-center gap-5 sm:gap-7">
                    <span className="flex h-[54px] w-[54px] shrink-0 items-center justify-center rounded-[14px] bg-[#fff3d5] font-serif text-[20px] font-bold text-[#c48607]">
                      {number}
                    </span>

                    <span className="hidden h-10 w-px shrink-0 bg-[#d7a51f]/55 sm:block" />

                    <h3 className="min-w-0 text-[17px] font-extrabold leading-snug text-[#06152f] sm:text-[19px] lg:text-[20px]">
                      {faq.question}
                    </h3>
                  </div>

                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-[#d7a51f] text-[26px] font-light leading-none text-[#b98512] transition-all duration-300">
                    +
                  </span>
                </button>
              )}
            </div>
          );
        })}
      </div>

      {/* Show More */}
      {service.faqs.length > 5 && (
        <div className="mt-10 text-center">
          <button
            type="button"
            onClick={() => setShowAllFaqs((prev) => !prev)}
            className="rounded-full bg-gradient-to-r from-[#c88908] to-[#dfaa1c] px-8 py-3.5 text-[15px] font-bold text-white shadow-[0_14px_30px_rgba(198,146,24,0.25)] transition hover:-translate-y-0.5 hover:shadow-[0_20px_40px_rgba(198,146,24,0.32)]"
          >
            {showAllFaqs ? "Show Less" : "Show More"}
          </button>
        </div>
      )}
    </div>
  </section>
)}
{showCustomerReviews && <Testimonials />}

     
      </main>

<Footer showCta />
    </div>
  );
};

export default ReleasePledgedGoldLocationPage;